import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, HostBinding, NgModule, Directive, HostListener, Injectable, Pipe, Inject, EventEmitter, Output, ViewChild, forwardRef, Host, Optional } from '@angular/core';
import * as i4 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i1$4 from '@angular/flex-layout';
import { FlexLayoutModule } from '@angular/flex-layout';
import * as i1$2 from '@angular/forms';
import { FormsModule, NG_VALIDATORS } from '@angular/forms';
import * as i2$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { NativeDateAdapter, DateAdapter } from '@angular/material/core';
import * as i1 from '@angular/cdk/platform';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i5 from '@angular/flex-layout/flex';
import * as i1$3 from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import * as i3$1 from '@angular/flex-layout/extended';
import * as i2$2 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i1$5 from '@agm/core';
import { AgmCoreModule } from '@agm/core';
import { HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { tap } from 'rxjs/operators';

const _c0$f = [[["", "alert-icon", ""]], "*"];
const _c1$7 = ["[alert-icon]", "*"];
class AlertComponent {
    constructor() {
        this.color = "primary";
    }
    get getClassPrimary() { return this.color == "primary"; }
    get getClassAccent() { return this.color == "accent"; }
    get getClassWarn() { return this.color == "warn"; }
    get getClassInfo() { return this.color == "info"; }
    get getClassSuccess() { return this.color == "success"; }
}
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(); };
AlertComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["alert"]], hostVars: 10, hostBindings: function AlertComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("alert-primary", ctx.getClassPrimary)("alert-accent", ctx.getClassAccent)("alert-warn", ctx.getClassWarn)("alert-info", ctx.getClassInfo)("alert-success", ctx.getClassSuccess);
    } }, inputs: { color: "color" }, ngContentSelectors: _c1$7, decls: 3, vars: 0, consts: [[1, "alert-content"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$f);
        i0.ɵɵprojection(0);
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵprojection(2, 1);
        i0.ɵɵelementEnd();
    } }, styles: ["alert{display:flex;flex-direction:row;align-items:flex-start;padding:10px 15px;border-radius:4px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}alert.alert-primary{background-color:#469769;color:#fff}alert.alert-accent{background-color:#976946;color:#fff}alert.alert-warn{background-color:#f15a4f;color:#fff}alert.alert-info{background-color:#2b8ae3;color:#fff}alert.alert-success{background-color:#4aa124;color:#fff}alert [alert-icon]{margin-right:10px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: "alert",
                templateUrl: "./AlertComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styleUrls: ["./AlertComponent.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { color: [{
            type: Input,
            args: ["color"]
        }], getClassPrimary: [{
            type: HostBinding,
            args: ["class.alert-primary"]
        }], getClassAccent: [{
            type: HostBinding,
            args: ["class.alert-accent"]
        }], getClassWarn: [{
            type: HostBinding,
            args: ["class.alert-warn"]
        }], getClassInfo: [{
            type: HostBinding,
            args: ["class.alert-info"]
        }], getClassSuccess: [{
            type: HostBinding,
            args: ["class.alert-success"]
        }] }); })();

class AlertModule {
}
AlertModule.ɵmod = i0.ɵɵdefineNgModule({ type: AlertModule });
AlertModule.ɵinj = i0.ɵɵdefineInjector({ factory: function AlertModule_Factory(t) { return new (t || AlertModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AlertModule, { declarations: [AlertComponent], imports: [CommonModule], exports: [AlertComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AlertModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                exports: [
                    AlertComponent,
                ],
                declarations: [
                    AlertComponent,
                ],
            }]
    }], null, null); })();

const _c0$e = ["*"];
class AvatarComponent {
}
AvatarComponent.ɵfac = function AvatarComponent_Factory(t) { return new (t || AvatarComponent)(); };
AvatarComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AvatarComponent, selectors: [["avatar"]], ngContentSelectors: _c0$e, decls: 1, vars: 0, template: function AvatarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:center;height:40px;width:40px;border-radius:50%;background-color:#976946;color:#fff;font-size:14px;font-weight:700}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AvatarComponent, [{
        type: Component,
        args: [{
                selector: "avatar",
                templateUrl: "./AvatarComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styleUrls: ["./AvatarComponent.scss"]
            }]
    }], null, null); })();

class AvatarModule {
}
AvatarModule.ɵmod = i0.ɵɵdefineNgModule({ type: AvatarModule });
AvatarModule.ɵinj = i0.ɵɵdefineInjector({ factory: function AvatarModule_Factory(t) { return new (t || AvatarModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AvatarModule, { declarations: [AvatarComponent], exports: [AvatarComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AvatarModule, [{
        type: NgModule,
        args: [{
                exports: [
                    AvatarComponent,
                ],
                declarations: [
                    AvatarComponent,
                ]
            }]
    }], null, null); })();

class CardBodyDirective {
}
CardBodyDirective.ɵfac = function CardBodyDirective_Factory(t) { return new (t || CardBodyDirective)(); };
CardBodyDirective.ɵdir = i0.ɵɵdefineDirective({ type: CardBodyDirective, selectors: [["card-body"]] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CardBodyDirective, [{
        type: Directive,
        args: [{
                selector: "card-body"
            }]
    }], null, null); })();

function CardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelement(2, "mat-progress-spinner", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@fadeIn", undefined);
} }
const _c0$d = ["*"];
class CardComponent {
    constructor() {
        this.themeBinding = true;
    }
    ngOnChanges() {
        this.cardSmBinding = this.size == "sm";
        this.cardMdBinding = this.size == "md";
        this.cardLgBinding = this.size == "lg";
        this.cardPrimaryBinding = this.color == "primary";
        this.cardAccentBinding = this.color == "accent";
        this.cardWarnBinding = this.color == "warn";
    }
}
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(); };
CardComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CardComponent, selectors: [["card"]], hostVars: 14, hostBindings: function CardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("theme-bg-card", ctx.themeBinding)("card-sm", ctx.cardSmBinding)("card-md", ctx.cardMdBinding)("card-lg", ctx.cardLgBinding)("card-primary", ctx.cardPrimaryBinding)("card-accent", ctx.cardAccentBinding)("card-warn", ctx.cardWarnBinding);
    } }, inputs: { size: "size", color: "color", showOverlay: "showOverlay" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$d, decls: 2, vars: 1, consts: [["class", "card-loading-overlay theme-bg-background", 4, "ngIf"], [1, "card-loading-overlay", "theme-bg-background"], [1, "card-loading-content", "theme-bg-card", "mat-elevation-z2"], ["mode", "indeterminate"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, CardComponent_div_0_Template, 3, 1, "div", 0);
        i0.ɵɵprojection(1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showOverlay);
    } }, directives: [i2.NgIf, i4.MatProgressSpinner], styles: ["card{display:block;border-radius:4px;position:relative;overflow:hidden;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}card>:first-child{border-top-left-radius:4px;border-top-right-radius:4px}card>:last-child:not(.card-loading){border-bottom-left-radius:4px;border-bottom-right-radius:4px}card.card-sm{min-width:350px;max-width:350px}card.card-md{min-width:350px;max-width:650px}card.card-lg{min-width:350px;max-width:900px}card.card-primary{background-color:rgba(70,151,105,.12)}card.card-accent{background-color:rgba(151,105,70,.12)}card.card-warn{background-color:rgba(241,90,79,.12)}card card-head{display:block}card card-head>.card-head-container{height:50px;padding:5px 10px;display:flex;flex-direction:row;align-items:center}card card-head>.card-head-container>.card-head-content{flex:1 1 auto;padding:0 5px;min-width:1px}card card-head>.card-head-container>.card-head-content>.card-head-title{font-size:16px;line-height:22px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}card card-head>.card-head-container>.card-head-content>.card-head-subtitle{font-size:12px;line-height:14px}card card-body{display:block;padding:15px}card card-head+card-body{padding-top:0}card card-foot{display:block;border-top:1px solid rgba(0,0,0,.12);padding:10px 15px}card>.card-loading-overlay{position:absolute;top:0;bottom:0;left:0;right:0;z-index:10;display:flex;flex-direction:column;border-radius:4px}card>.card-loading-overlay>.card-loading-content{margin:auto;padding:10px;border-radius:50%}"], encapsulation: 2, data: { animation: [
            trigger("fadeIn", [
                transition("void => *", [
                    style({ opacity: "0" }),
                    animate("100ms", style({ opacity: "1" }))
                ]),
                transition("* => void", [
                    style({ opacity: "1" }),
                    animate("100ms", style({ opacity: "0" }))
                ])
            ])
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{
                selector: "card",
                templateUrl: "./CardComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styleUrls: ["./CardComponent.scss"],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger("fadeIn", [
                        transition("void => *", [
                            style({ opacity: "0" }),
                            animate("100ms", style({ opacity: "1" }))
                        ]),
                        transition("* => void", [
                            style({ opacity: "1" }),
                            animate("100ms", style({ opacity: "0" }))
                        ])
                    ])
                ]
            }]
    }], null, { themeBinding: [{
            type: HostBinding,
            args: ["class.theme-bg-card"]
        }], cardSmBinding: [{
            type: HostBinding,
            args: ["class.card-sm"]
        }], cardMdBinding: [{
            type: HostBinding,
            args: ["class.card-md"]
        }], cardLgBinding: [{
            type: HostBinding,
            args: ["class.card-lg"]
        }], cardPrimaryBinding: [{
            type: HostBinding,
            args: ["class.card-primary"]
        }], cardAccentBinding: [{
            type: HostBinding,
            args: ["class.card-accent"]
        }], cardWarnBinding: [{
            type: HostBinding,
            args: ["class.card-warn"]
        }], size: [{
            type: Input
        }], color: [{
            type: Input
        }], showOverlay: [{
            type: Input
        }] }); })();

class CardFootDirective {
}
CardFootDirective.ɵfac = function CardFootDirective_Factory(t) { return new (t || CardFootDirective)(); };
CardFootDirective.ɵdir = i0.ɵɵdefineDirective({ type: CardFootDirective, selectors: [["card-foot"]] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CardFootDirective, [{
        type: Directive,
        args: [{
                selector: "card-foot"
            }]
    }], null, null); })();

const _c0$c = [[["", "card-head-prefix", ""]], "*", [["", "card-head-subtitle", ""]], [["", "card-head-suffix", ""]]];
const _c1$6 = ["[card-head-prefix]", "*", "[card-head-subtitle]", "[card-head-suffix]"];
class CardHeadComponent {
}
CardHeadComponent.ɵfac = function CardHeadComponent_Factory(t) { return new (t || CardHeadComponent)(); };
CardHeadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CardHeadComponent, selectors: [["card-head"]], ngContentSelectors: _c1$6, decls: 8, vars: 0, consts: [[1, "card-head-container"], [1, "card-head-content"], [1, "card-head-title"], [1, "card-head-subtitle"]], template: function CardHeadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$c);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(7, 3);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CardHeadComponent, [{
        type: Component,
        args: [{
                selector: "card-head",
                templateUrl: "./CardHeadComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class CardModule {
}
CardModule.ɵmod = i0.ɵɵdefineNgModule({ type: CardModule });
CardModule.ɵinj = i0.ɵɵdefineInjector({ factory: function CardModule_Factory(t) { return new (t || CardModule)(); }, imports: [[
            CommonModule,
            MatProgressSpinnerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CardModule, { declarations: [CardComponent,
        CardBodyDirective,
        CardFootDirective,
        CardHeadComponent], imports: [CommonModule,
        MatProgressSpinnerModule], exports: [CardComponent,
        CardBodyDirective,
        CardFootDirective,
        CardHeadComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatProgressSpinnerModule
                ],
                exports: [
                    CardComponent,
                    CardBodyDirective,
                    CardFootDirective,
                    CardHeadComponent,
                ],
                declarations: [
                    CardComponent,
                    CardBodyDirective,
                    CardFootDirective,
                    CardHeadComponent,
                ]
            }]
    }], null, null); })();

class ExpandableDirective {
    constructor() {
        this.classExpandableBinding = true;
        this.classExpandableCollapseBinding = true;
    }
}
ExpandableDirective.ɵfac = function ExpandableDirective_Factory(t) { return new (t || ExpandableDirective)(); };
ExpandableDirective.ɵdir = i0.ɵɵdefineDirective({ type: ExpandableDirective, selectors: [["", "expandable", ""]], hostVars: 4, hostBindings: function ExpandableDirective_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("expandable", ctx.classExpandableBinding)("expandable-collapse", ctx.classExpandableCollapseBinding);
    } }, exportAs: ["expandable"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ExpandableDirective, [{
        type: Directive,
        args: [{
                selector: "[expandable]",
                exportAs: "expandable"
            }]
    }], function () { return []; }, { classExpandableBinding: [{
            type: HostBinding,
            args: ["class.expandable"]
        }], classExpandableCollapseBinding: [{
            type: HostBinding,
            args: ["class.expandable-collapse"]
        }] }); })();

class ExpandableToggleDirective {
    constructor(element) {
        this.element = element;
    }
    clickHandler() {
        this.expandable.classExpandableCollapseBinding = !this.expandable.classExpandableCollapseBinding;
    }
}
ExpandableToggleDirective.ɵfac = function ExpandableToggleDirective_Factory(t) { return new (t || ExpandableToggleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ExpandableToggleDirective.ɵdir = i0.ɵɵdefineDirective({ type: ExpandableToggleDirective, selectors: [["", "expandableToggle", ""]], hostBindings: function ExpandableToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ExpandableToggleDirective_click_HostBindingHandler() { return ctx.clickHandler(); });
    } }, inputs: { expandable: ["expandableToggle", "expandable"] } });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ExpandableToggleDirective, [{
        type: Directive,
        args: [{
                selector: "[expandableToggle]"
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { expandable: [{
            type: Input,
            args: ["expandableToggle"]
        }], clickHandler: [{
            type: HostListener,
            args: ["click"]
        }] }); })();

class LetDirective {
    constructor(vcRef, templateRef) {
        this.vcRef = vcRef;
        this.templateRef = templateRef;
        this.context = {};
    }
    set let(context) {
        this.context.$implicit = this.context.let = context;
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
}
LetDirective.ɵfac = function LetDirective_Factory(t) { return new (t || LetDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef)); };
LetDirective.ɵdir = i0.ɵɵdefineDirective({ type: LetDirective, selectors: [["", "let", ""]], inputs: { let: "let" } });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LetDirective, [{
        type: Directive,
        args: [{
                selector: "[let]",
            }]
    }], function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, { let: [{
            type: Input
        }] }); })();

class SharedCommonModule {
}
SharedCommonModule.ɵmod = i0.ɵɵdefineNgModule({ type: SharedCommonModule });
SharedCommonModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SharedCommonModule_Factory(t) { return new (t || SharedCommonModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SharedCommonModule, { declarations: [ExpandableDirective,
        ExpandableToggleDirective,
        LetDirective], exports: [ExpandableDirective,
        ExpandableToggleDirective,
        LetDirective] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SharedCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ExpandableDirective,
                    ExpandableToggleDirective,
                    LetDirective,
                ],
                exports: [
                    ExpandableDirective,
                    ExpandableToggleDirective,
                    LetDirective,
                ]
            }]
    }], null, null); })();

class SnackBarConfig {
}
SnackBarConfig.DEFAULT = {
    duration: 3000,
    verticalPosition: "top"
};
SnackBarConfig.SUCCESS = {
    duration: 3000,
    panelClass: "mat-snackbar-success",
    verticalPosition: "top"
};
SnackBarConfig.WARN = {
    duration: 5000,
    panelClass: "mat-snackbar-warn",
    verticalPosition: "top"
};
SnackBarConfig.INFO = {
    duration: 3000,
    panelClass: "mat-snackbar-info",
    verticalPosition: "top"
};

class UtcDateAdapter extends NativeDateAdapter {
    constructor(platform) {
        super("en-GB", platform);
        this.inputFormat = "^\\s*[0-9]{1,2}\\s*\\/\\s*[0-9]{1,2}\\s*\\/\\s*[0-9]{1,4}\\s*$";
    }
    addCalendarYears(date, years) {
        let newDate = new Date(date);
        newDate.setFullYear(newDate.getFullYear() + years);
        const year = newDate.getFullYear();
        const month = newDate.getMonth();
        const day = newDate.getDate();
        return this.createDate(year, month, day);
    }
    addCalendarMonths(date, months) {
        let newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + months);
        const year = newDate.getFullYear();
        const month = newDate.getMonth();
        const day = newDate.getDate();
        return this.createDate(year, month, day);
    }
    addCalendarDays(date, days) {
        let newDate = new Date(date);
        newDate.setDate(newDate.getDate() + days);
        const year = newDate.getFullYear();
        const month = newDate.getMonth();
        const day = newDate.getDate();
        return this.createDate(year, month, day);
    }
    createDate(year, month, date) {
        return this.createUtc(year, month + 1, date);
    }
    format(input, displayFormat) {
        let year = input.getUTCFullYear();
        let month = input.getUTCMonth() + 1;
        let date = input.getUTCDate();
        if (displayFormat.hasOwnProperty("day")) {
            return this.formatYearMonthDate(year, month, date);
        }
        else {
            return this.formatYearMonth(year, month);
        }
    }
    getYear(date) {
        return date.getUTCFullYear();
    }
    getYearName(date) {
        return date.getUTCFullYear().toString();
    }
    getMonth(date) {
        return date.getUTCMonth();
    }
    getDate(date) {
        return date.getUTCDate();
    }
    getDayOfWeek(date) {
        return date.getUTCDay();
    }
    getNumDaysInMonth(date) {
        let endOfMonth = new Date(date);
        endOfMonth.setDate(1);
        endOfMonth.setMonth(endOfMonth.getMonth() + 1);
        endOfMonth.setDate(endOfMonth.getDate() - 1);
        return endOfMonth.getDate();
    }
    parse(input) {
        return this.parseUtc(input);
    }
    today() {
        let now = new Date();
        let todayUtc = this.createUtc(now.getFullYear(), now.getMonth() + 1, now.getDate());
        return todayUtc;
    }
    createUtc(year, month, date) {
        let isoDate = ("000" + year).slice(-4) + "-" + ("0" + month).slice(-2) + "-" + ("0" + date).slice(-2) + "T00:00:00Z";
        let utcDate = new Date(isoDate);
        return utcDate;
    }
    formatYearMonthDate(year, month, date) {
        return ("00" + date).slice(-2) + "/" + ("00" + month).slice(-2) + "/" + year;
    }
    formatYearMonth(year, month) {
        return this.getMonthName(month).substr(0, 3) + " " + year;
    }
    getMonthName(month) {
        switch (month) {
            case 1: return "January";
            case 2: return "February";
            case 3: return "March";
            case 4: return "April";
            case 5: return "May";
            case 6: return "June";
            case 7: return "July";
            case 8: return "August";
            case 9: return "September";
            case 10: return "October";
            case 11: return "November";
            case 12: return "December";
        }
    }
    parseUtc(input) {
        try {
            if (input.match(this.inputFormat)) {
                let dateParts = input.split("/");
                let date = +dateParts[0];
                let month = +dateParts[1];
                let year = +dateParts[2];
                let utcDate = this.createUtc(year, month, date);
                // verify that the date is legit
                if (utcDate.getUTCDate() == date
                    && utcDate.getUTCMonth() == (month - 1)
                    && utcDate.getUTCFullYear() == year) {
                    return utcDate;
                }
            }
        }
        catch (ex) { }
        return null;
    }
}
UtcDateAdapter.ɵfac = function UtcDateAdapter_Factory(t) { return new (t || UtcDateAdapter)(i0.ɵɵinject(i1.Platform)); };
UtcDateAdapter.ɵprov = i0.ɵɵdefineInjectable({ token: UtcDateAdapter, factory: UtcDateAdapter.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UtcDateAdapter, [{
        type: Injectable
    }], function () { return [{ type: i1.Platform }]; }, null); })();

class UtcDateDirective {
}
UtcDateDirective.ɵfac = function UtcDateDirective_Factory(t) { return new (t || UtcDateDirective)(); };
UtcDateDirective.ɵdir = i0.ɵɵdefineDirective({ type: UtcDateDirective, selectors: [["", "utc-date", ""]], features: [i0.ɵɵProvidersFeature([{ provide: DateAdapter, useClass: UtcDateAdapter }])] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UtcDateDirective, [{
        type: Directive,
        args: [{
                selector: "[utc-date]",
                providers: [{ provide: DateAdapter, useClass: UtcDateAdapter }]
            }]
    }], null, null); })();

class DateUtility {
    static getLocalTimeString() {
        let localDate = new Date();
        let localHour = localDate.getHours();
        let localMinute = localDate.getMinutes();
        let localAmPm = localHour >= 12 ? "PM" : "AM";
        if (localHour > 12) {
            localHour -= 12;
        }
        if (localHour == 0) {
            localHour = 12;
        }
        return localHour + ":" + ("0" + localMinute).slice(-2) + " " + localAmPm;
    }
    static getLocalToday() {
        let now = new Date();
        let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return today;
    }
    static getUtcToday() {
        let today = this.getLocalToday();
        let utc = this.toUtc(today);
        return utc;
    }
    static getMostRecentDayOfWeek(startDate, dayOfWeek) {
        let mostRecentDayOfWeek = new Date(startDate);
        while (mostRecentDayOfWeek.getDay() != dayOfWeek) {
            mostRecentDayOfWeek.setDate(mostRecentDayOfWeek.getDate() - 1);
        }
        return mostRecentDayOfWeek;
    }
    static parse(input) {
        try {
            if (input.match("^\\s*[0-9]{1,2}\\s*\\/\\s*[0-9]{1,2}\\s*\\/\\s*[0-9]{1,4}\\s*$")) {
                let dateParts = input.split("/");
                let date = +dateParts[0];
                let month = +dateParts[1];
                let year = +dateParts[2];
                let localDate = new Date(year, month - 1, date);
                // verify that the date is legit
                if (localDate.getDate() == date
                    && localDate.getMonth() == (month - 1)
                    && localDate.getFullYear() == year) {
                    return localDate;
                }
            }
        }
        catch (ex) { }
        return null;
    }
    static parseLocalTime(input) {
        try {
            let match = input.match("^\\s*([0-9]{1,2})\\s*:\\s*([0-9]{1,2})\\s*(AM|PM)$");
            if (match) {
                let hours = +match[1];
                let minutes = +match[2];
                if (match[3] == "PM" && hours < 12) {
                    hours += 12;
                }
                return new Date(`0001-01-01T${("0" + hours).slice(-2)}:${("0" + minutes).slice(-2)}`);
            }
        }
        catch (ex) { }
        return null;
    }
    static toUtc(input) {
        let offsetMs = input.getTimezoneOffset() * 60 * 1000;
        let utc = new Date(input.getTime() - offsetMs);
        return utc;
    }
    static toLocal(utcDate) {
        let utcDateOffsetMs = utcDate.getTimezoneOffset() * this.MS_PER_MINUTE;
        let localDate = new Date(utcDate.getTime() + utcDateOffsetMs);
        let localDateOffsetMs = localDate.getTimezoneOffset() * this.MS_PER_MINUTE;
        if (utcDateOffsetMs != localDateOffsetMs) {
            let localOffsetDeltaMs = utcDateOffsetMs - localDateOffsetMs;
            localDate = new Date(localDate.getTime() - localOffsetDeltaMs);
        }
        return localDate;
    }
    static toIsoDateString(input) {
        let year = input.getFullYear();
        let month = input.getMonth() + 1;
        let date = input.getDate();
        return `${("000" + year).slice(-4)}-${("0" + month).slice(-2)}-${("0" + date).slice(-2)}`;
    }
}
DateUtility.MS_PER_MINUTE = 60000;

class UtcDatePipe {
    transform(date) {
        if (date != null) {
            if (typeof date === "string") {
                date = new Date(date);
            }
            return DateUtility.toLocal(date);
        }
        return null;
    }
}
UtcDatePipe.ɵfac = function UtcDatePipe_Factory(t) { return new (t || UtcDatePipe)(); };
UtcDatePipe.ɵpipe = i0.ɵɵdefinePipe({ name: "utcDate", type: UtcDatePipe, pure: true });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UtcDatePipe, [{
        type: Pipe,
        args: [{
                name: "utcDate"
            }]
    }], null, null); })();

class DateModule {
}
DateModule.ɵmod = i0.ɵɵdefineNgModule({ type: DateModule });
DateModule.ɵinj = i0.ɵɵdefineInjector({ factory: function DateModule_Factory(t) { return new (t || DateModule)(); }, imports: [[
            CommonModule,
            FlexLayoutModule,
            MatButtonModule,
            MatIconModule,
            MatProgressSpinnerModule,
            MatSnackBarModule,
            FormsModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DateModule, { declarations: [UtcDateDirective,
        UtcDatePipe], imports: [CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        FormsModule,
        RouterModule], exports: [UtcDateDirective,
        UtcDatePipe] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DateModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FlexLayoutModule,
                    MatButtonModule,
                    MatIconModule,
                    MatProgressSpinnerModule,
                    MatSnackBarModule,
                    FormsModule,
                    RouterModule
                ],
                exports: [
                    UtcDateDirective,
                    UtcDatePipe
                ],
                declarations: [
                    UtcDateDirective,
                    UtcDatePipe
                ]
            }]
    }], null, null); })();

class DialogAlertViewModel {
    constructor() {
        this.title = "Alert";
        this.message = "Message";
        this.confirm = "OK";
    }
}

class DialogAlertComponent {
    constructor(dialogRef, model) {
        this.dialogRef = dialogRef;
        this.model = model;
    }
}
DialogAlertComponent.ɵfac = function DialogAlertComponent_Factory(t) { return new (t || DialogAlertComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DialogAlertComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DialogAlertComponent, selectors: [["dialog-alert"]], decls: 8, vars: 3, consts: [["mat-dialog-title", ""], ["mat-dialog-content", "", 2, "white-space", "pre-wrap"], ["mat-dialog-actions", ""], ["fxFlex", ""], ["mat-button", "", 3, "click"]], template: function DialogAlertComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h2", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelement(5, "span", 3);
        i0.ɵɵelementStart(6, "button", 4);
        i0.ɵɵlistener("click", function DialogAlertComponent_Template_button_click_6_listener() { return ctx.dialogRef.close(true); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.model.title, "\n");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.model.message);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.model.confirm, " ");
    } }, directives: [i1$1.MatDialogTitle, i1$1.MatDialogContent, i1$1.MatDialogActions, i5.DefaultFlexDirective, i2$1.MatButton], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DialogAlertComponent, [{
        type: Component,
        args: [{
                selector: "dialog-alert",
                templateUrl: "./DialogAlertComponent.html"
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: DialogAlertViewModel, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class DialogConfirmViewModel {
    constructor() {
        this.title = "Confirm";
        this.message = "Please confirm.";
        this.cancel = "CANCEL";
        this.showCancel = true;
        this.confirm = "CONFIRM";
        this.confirmColor = "primary";
    }
}

function DialogConfirmComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function DialogConfirmComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.dialogRef.close(false); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.cancel, " ");
} }
class DialogConfirmComponent {
    constructor(dialogRef, model) {
        this.dialogRef = dialogRef;
        this.model = model;
    }
}
DialogConfirmComponent.ɵfac = function DialogConfirmComponent_Factory(t) { return new (t || DialogConfirmComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DialogConfirmComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DialogConfirmComponent, selectors: [["dialog-confirm"]], decls: 9, vars: 5, consts: [["mat-dialog-title", ""], ["mat-dialog-content", "", 2, "white-space", "pre-wrap"], ["mat-dialog-actions", ""], ["fxFlex", ""], ["mat-button", "", "class", "mr-1", 3, "click", 4, "ngIf"], ["mat-raised-button", "", 3, "color", "click"], ["mat-button", "", 1, "mr-1", 3, "click"]], template: function DialogConfirmComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h2", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelement(5, "span", 3);
        i0.ɵɵtemplate(6, DialogConfirmComponent_button_6_Template, 2, 1, "button", 4);
        i0.ɵɵelementStart(7, "button", 5);
        i0.ɵɵlistener("click", function DialogConfirmComponent_Template_button_click_7_listener() { return ctx.dialogRef.close(true); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.model.title, "\n");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.model.message);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.model.showCancel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("color", ctx.model.confirmColor);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.model.confirm, " ");
    } }, directives: [i1$1.MatDialogTitle, i1$1.MatDialogContent, i1$1.MatDialogActions, i5.DefaultFlexDirective, i2.NgIf, i2$1.MatButton], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DialogConfirmComponent, [{
        type: Component,
        args: [{
                selector: "dialog-confirm",
                templateUrl: "./DialogConfirmComponent.html"
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: DialogConfirmViewModel, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class AutoFocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        setTimeout(() => {
            this.setFocus();
        }, 250);
    }
    setFocus() {
        this.elementRef.nativeElement.focus();
    }
}
AutoFocusDirective.ɵfac = function AutoFocusDirective_Factory(t) { return new (t || AutoFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
AutoFocusDirective.ɵdir = i0.ɵɵdefineDirective({ type: AutoFocusDirective, selectors: [["", "auto-focus", ""]] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AutoFocusDirective, [{
        type: Directive,
        args: [{
                selector: "[auto-focus]"
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();

class AutoSelectDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    onFocus() {
        if (this.elementRef.nativeElement.value && this.elementRef.nativeElement.value.length) {
            this.elementRef.nativeElement.select();
        }
    }
}
AutoSelectDirective.ɵfac = function AutoSelectDirective_Factory(t) { return new (t || AutoSelectDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
AutoSelectDirective.ɵdir = i0.ɵɵdefineDirective({ type: AutoSelectDirective, selectors: [["", "auto-select", ""]], hostBindings: function AutoSelectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("focus", function AutoSelectDirective_focus_HostBindingHandler() { return ctx.onFocus(); });
    } } });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AutoSelectDirective, [{
        type: Directive,
        args: [{
                selector: "[auto-select]"
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { onFocus: [{
            type: HostListener,
            args: ["focus"]
        }] }); })();

class ForbiddenValueValidatorDirective {
    validate(control) {
        if (this.forbiddenValue != null
            && control.value != null
            && this.forbiddenValue == control.value) {
            return {
                forbiddenValue: true
            };
        }
        return null;
    }
    registerOnValidatorChange(fn) {
        this.registerValidatorChanged = fn;
    }
    ngOnChanges() {
        if (this.registerValidatorChanged) {
            setTimeout(() => {
                this.registerValidatorChanged();
            }, 0);
        }
    }
}
ForbiddenValueValidatorDirective.ɵfac = function ForbiddenValueValidatorDirective_Factory(t) { return new (t || ForbiddenValueValidatorDirective)(); };
ForbiddenValueValidatorDirective.ɵdir = i0.ɵɵdefineDirective({ type: ForbiddenValueValidatorDirective, selectors: [["", "forbiddenValue", ""]], inputs: { forbiddenValue: "forbiddenValue" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: ForbiddenValueValidatorDirective, multi: true }]), i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ForbiddenValueValidatorDirective, [{
        type: Directive,
        args: [{
                selector: "[forbiddenValue]",
                providers: [{ provide: NG_VALIDATORS, useExisting: ForbiddenValueValidatorDirective, multi: true }]
            }]
    }], null, { forbiddenValue: [{
            type: Input,
            args: ["forbiddenValue"]
        }] }); })();

class FormHelperDirective {
    constructor(elementRef, ngForm) {
        this.elementRef = elementRef;
        this.ngForm = ngForm;
    }
    showErrors() {
        if (this.ngForm != null) {
            this.markFormAsTouched(this.ngForm);
            setTimeout(() => {
                this.focusFirstError();
            });
        }
    }
    focusFirstError() {
        let input = this.elementRef.nativeElement.querySelector("input.ng-invalid, textarea.ng-invalid, select.ng-invalid, mat-select.ng-invalid");
        if (input != null) {
            input.focus();
        }
    }
    markControlAsTouched(control) {
        control.markAsTouched();
        control.updateValueAndValidity();
    }
    markFormAsTouched(form) {
        form.control.markAsTouched();
        form.control.updateValueAndValidity();
        for (let controlKey in form.controls) {
            let control = form.controls[controlKey];
            this.markControlAsTouched(control);
        }
    }
}
FormHelperDirective.ɵfac = function FormHelperDirective_Factory(t) { return new (t || FormHelperDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.NgForm)); };
FormHelperDirective.ɵdir = i0.ɵɵdefineDirective({ type: FormHelperDirective, selectors: [["", "formHelper", ""]], exportAs: ["formHelper"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FormHelperDirective, [{
        type: Directive,
        args: [{
                selector: "[formHelper]",
                exportAs: "formHelper"
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1$2.NgForm }]; }, null); })();

class IsValidValidatorDirective {
    validate(control) {
        if (typeof this.isValid == "undefined") {
            return {
                isValid: true
            };
        }
        else if (typeof this.isValid == "boolean") {
            if (!this.isValid) {
                return {
                    isValid: true
                };
            }
        }
        else if (typeof this.isValid == "object") {
            for (let key in this.isValid) {
                if (!this.isValid[key]) {
                    let error = {};
                    error[key] = true;
                    return error;
                }
            }
        }
        return null;
    }
    registerOnValidatorChange(fn) {
        this.registerValidatorChanged = fn;
    }
    ngOnChanges() {
        if (this.registerValidatorChanged) {
            setTimeout(() => {
                this.registerValidatorChanged();
            }, 0);
        }
    }
}
IsValidValidatorDirective.ɵfac = function IsValidValidatorDirective_Factory(t) { return new (t || IsValidValidatorDirective)(); };
IsValidValidatorDirective.ɵdir = i0.ɵɵdefineDirective({ type: IsValidValidatorDirective, selectors: [["", "isValid", ""]], inputs: { isValid: "isValid" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: IsValidValidatorDirective, multi: true }]), i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(IsValidValidatorDirective, [{
        type: Directive,
        args: [{
                selector: "[isValid]",
                providers: [{ provide: NG_VALIDATORS, useExisting: IsValidValidatorDirective, multi: true }]
            }]
    }], null, { isValid: [{
            type: Input,
            args: ["isValid"]
        }] }); })();

class MatSelectAllButtonsComponent {
    constructor(matSelect) {
        this.matSelect = matSelect;
    }
    selectAll() {
        this.matSelect.options.forEach(o => o.select());
    }
    deselectAll() {
        this.matSelect.options.forEach(o => o.deselect());
    }
}
MatSelectAllButtonsComponent.ɵfac = function MatSelectAllButtonsComponent_Factory(t) { return new (t || MatSelectAllButtonsComponent)(i0.ɵɵdirectiveInject(i1$3.MatSelect)); };
MatSelectAllButtonsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatSelectAllButtonsComponent, selectors: [["mat-select-all-buttons"]], hostAttrs: [1, "mat-option"], decls: 4, vars: 0, consts: [["mat-button", "", "color", "default", 3, "click"], ["mat-button", "", "color", "default", 1, "ml-2", 3, "click"]], template: function MatSelectAllButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function MatSelectAllButtonsComponent_Template_button_click_0_listener() { return ctx.selectAll(); });
        i0.ɵɵtext(1, " Select All\n");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "button", 1);
        i0.ɵɵlistener("click", function MatSelectAllButtonsComponent_Template_button_click_2_listener() { return ctx.deselectAll(); });
        i0.ɵɵtext(3, " Deselect All\n");
        i0.ɵɵelementEnd();
    } }, directives: [i2$1.MatButton], styles: ["[_nghost-%COMP%]{background:inherit!important}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MatSelectAllButtonsComponent, [{
        type: Component,
        args: [{
                selector: "mat-select-all-buttons",
                templateUrl: "./MatSelectAllButtonsComponent.html",
                styleUrls: ["./MatSelectAllButtonsComponent.scss"],
                host: {
                    class: "mat-option"
                }
            }]
    }], function () { return [{ type: i1$3.MatSelect }]; }, null); })();

class MaxNumberValidatorDirective {
    validate(control) {
        if (control.value != null && this.max != null) {
            let max = Number(this.max);
            let value = Number(control.value);
            if (!isNaN(max) && !isNaN(value) && max < value) {
                return {
                    max: true
                };
            }
        }
        return null;
    }
    registerOnValidatorChange(fn) {
        this.registerValidatorChanged = fn;
    }
    ngOnChanges() {
        if (this.registerValidatorChanged) {
            setTimeout(() => {
                this.registerValidatorChanged();
            }, 0);
        }
    }
}
MaxNumberValidatorDirective.ɵfac = function MaxNumberValidatorDirective_Factory(t) { return new (t || MaxNumberValidatorDirective)(); };
MaxNumberValidatorDirective.ɵdir = i0.ɵɵdefineDirective({ type: MaxNumberValidatorDirective, selectors: [["input", "type", "number", "max", ""]], inputs: { max: "max" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MaxNumberValidatorDirective, multi: true }]), i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MaxNumberValidatorDirective, [{
        type: Directive,
        args: [{
                selector: "input[type=number][max]",
                providers: [{ provide: NG_VALIDATORS, useExisting: MaxNumberValidatorDirective, multi: true }]
            }]
    }], null, { max: [{
            type: Input,
            args: ["max"]
        }] }); })();

class MinNumberValidatorDirective {
    validate(control) {
        if (control.value != null && this.min != null) {
            let min = Number(this.min);
            let value = Number(control.value);
            if (!isNaN(min) && !isNaN(value) && min > value) {
                return {
                    min: true
                };
            }
        }
        return null;
    }
    registerOnValidatorChange(fn) {
        this.registerValidatorChanged = fn;
    }
    ngOnChanges() {
        if (this.registerValidatorChanged) {
            setTimeout(() => {
                this.registerValidatorChanged();
            }, 0);
        }
    }
}
MinNumberValidatorDirective.ɵfac = function MinNumberValidatorDirective_Factory(t) { return new (t || MinNumberValidatorDirective)(); };
MinNumberValidatorDirective.ɵdir = i0.ɵɵdefineDirective({ type: MinNumberValidatorDirective, selectors: [["input", "type", "number", "min", ""]], inputs: { min: "min" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MinNumberValidatorDirective, multi: true }]), i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MinNumberValidatorDirective, [{
        type: Directive,
        args: [{
                selector: "input[type=number][min]",
                providers: [{ provide: NG_VALIDATORS, useExisting: MinNumberValidatorDirective, multi: true }]
            }]
    }], null, { min: [{
            type: Input,
            args: ["min"]
        }] }); })();

class RequiredValueValidatorDirective {
    validate(control) {
        if (this.requiredValue != null
            && control.value != null
            && this.requiredValue != control.value) {
            return {
                requiredValue: true
            };
        }
        return null;
    }
    registerOnValidatorChange(fn) {
        this.registerValidatorChanged = fn;
    }
    ngOnChanges() {
        if (this.registerValidatorChanged) {
            setTimeout(() => {
                this.registerValidatorChanged();
            }, 0);
        }
    }
}
RequiredValueValidatorDirective.ɵfac = function RequiredValueValidatorDirective_Factory(t) { return new (t || RequiredValueValidatorDirective)(); };
RequiredValueValidatorDirective.ɵdir = i0.ɵɵdefineDirective({ type: RequiredValueValidatorDirective, selectors: [["", "requiredValue", ""]], inputs: { requiredValue: "requiredValue" }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: RequiredValueValidatorDirective, multi: true }]), i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(RequiredValueValidatorDirective, [{
        type: Directive,
        args: [{
                selector: "[requiredValue]",
                providers: [{ provide: NG_VALIDATORS, useExisting: RequiredValueValidatorDirective, multi: true }]
            }]
    }], null, { requiredValue: [{
            type: Input,
            args: ["requiredValue"]
        }] }); })();

class FormExtensionsModule {
}
FormExtensionsModule.ɵmod = i0.ɵɵdefineNgModule({ type: FormExtensionsModule });
FormExtensionsModule.ɵinj = i0.ɵɵdefineInjector({ factory: function FormExtensionsModule_Factory(t) { return new (t || FormExtensionsModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatButtonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormExtensionsModule, { declarations: [AutoFocusDirective,
        AutoSelectDirective,
        FormHelperDirective,
        IsValidValidatorDirective,
        ForbiddenValueValidatorDirective,
        RequiredValueValidatorDirective,
        MaxNumberValidatorDirective,
        MinNumberValidatorDirective,
        MatSelectAllButtonsComponent], imports: [CommonModule,
        FormsModule,
        MatButtonModule], exports: [AutoFocusDirective,
        AutoSelectDirective,
        FormHelperDirective,
        IsValidValidatorDirective,
        ForbiddenValueValidatorDirective,
        RequiredValueValidatorDirective,
        MaxNumberValidatorDirective,
        MinNumberValidatorDirective,
        MatSelectAllButtonsComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FormExtensionsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatButtonModule,
                ],
                exports: [
                    AutoFocusDirective,
                    AutoSelectDirective,
                    FormHelperDirective,
                    IsValidValidatorDirective,
                    ForbiddenValueValidatorDirective,
                    RequiredValueValidatorDirective,
                    MaxNumberValidatorDirective,
                    MinNumberValidatorDirective,
                    MatSelectAllButtonsComponent
                ],
                declarations: [
                    AutoFocusDirective,
                    AutoSelectDirective,
                    FormHelperDirective,
                    IsValidValidatorDirective,
                    ForbiddenValueValidatorDirective,
                    RequiredValueValidatorDirective,
                    MaxNumberValidatorDirective,
                    MinNumberValidatorDirective,
                    MatSelectAllButtonsComponent
                ]
            }]
    }], null, null); })();

class DialogModule {
}
DialogModule.ɵmod = i0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = i0.ɵɵdefineInjector({ factory: function DialogModule_Factory(t) { return new (t || DialogModule)(); }, imports: [[
            CommonModule,
            FlexLayoutModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule,
            MatInputModule,
            MatFormFieldModule,
            FormExtensionsModule,
            FormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DialogModule, { declarations: [DialogAlertComponent,
        DialogConfirmComponent], imports: [CommonModule,
        FlexLayoutModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        FormExtensionsModule,
        FormsModule], exports: [DialogAlertComponent,
        DialogConfirmComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FlexLayoutModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatIconModule,
                    MatInputModule,
                    MatFormFieldModule,
                    FormExtensionsModule,
                    FormsModule,
                ],
                exports: [
                    DialogAlertComponent,
                    DialogConfirmComponent
                ],
                declarations: [
                    DialogAlertComponent,
                    DialogConfirmComponent
                ],
                entryComponents: [
                    DialogAlertComponent,
                    DialogConfirmComponent
                ]
            }]
    }], null, null); })();

var AppNotificationType;
(function (AppNotificationType) {
    AppNotificationType[AppNotificationType["GeneralMessage"] = 0] = "GeneralMessage";
})(AppNotificationType || (AppNotificationType = {}));

var BookedThroughType;
(function (BookedThroughType) {
    BookedThroughType[BookedThroughType["Branch"] = 1] = "Branch";
    BookedThroughType[BookedThroughType["Group"] = 2] = "Group";
})(BookedThroughType || (BookedThroughType = {}));

var ChecklistStatus;
(function (ChecklistStatus) {
    ChecklistStatus[ChecklistStatus["Active"] = 1] = "Active";
    ChecklistStatus[ChecklistStatus["Inactive"] = 2] = "Inactive";
})(ChecklistStatus || (ChecklistStatus = {}));

var EntityAction;
(function (EntityAction) {
    EntityAction[EntityAction["Create"] = 1] = "Create";
    EntityAction[EntityAction["Update"] = 2] = "Update";
    EntityAction[EntityAction["Delete"] = 3] = "Delete";
})(EntityAction || (EntityAction = {}));

var InspectionChecklistItemResultStatus;
(function (InspectionChecklistItemResultStatus) {
    InspectionChecklistItemResultStatus[InspectionChecklistItemResultStatus["Pass"] = 1] = "Pass";
    InspectionChecklistItemResultStatus[InspectionChecklistItemResultStatus["Fail"] = 2] = "Fail";
    InspectionChecklistItemResultStatus[InspectionChecklistItemResultStatus["NotApplicable"] = 3] = "NotApplicable";
    InspectionChecklistItemResultStatus[InspectionChecklistItemResultStatus["Advisory"] = 4] = "Advisory";
})(InspectionChecklistItemResultStatus || (InspectionChecklistItemResultStatus = {}));

var InspectionStatus;
(function (InspectionStatus) {
    InspectionStatus[InspectionStatus["Pending"] = 1] = "Pending";
    InspectionStatus[InspectionStatus["Completed"] = 2] = "Completed";
})(InspectionStatus || (InspectionStatus = {}));

var LightConditionStatus;
(function (LightConditionStatus) {
    LightConditionStatus[LightConditionStatus["Good"] = 1] = "Good";
    LightConditionStatus[LightConditionStatus["Fair"] = 2] = "Fair";
    LightConditionStatus[LightConditionStatus["Poor"] = 3] = "Poor";
})(LightConditionStatus || (LightConditionStatus = {}));

var PassphraseResetResult;
(function (PassphraseResetResult) {
    PassphraseResetResult[PassphraseResetResult["InvalidToken"] = 0] = "InvalidToken";
    PassphraseResetResult[PassphraseResetResult["IncomplexPassphrase"] = 1] = "IncomplexPassphrase";
    PassphraseResetResult[PassphraseResetResult["Success"] = 2] = "Success";
})(PassphraseResetResult || (PassphraseResetResult = {}));

var UserEventType;
(function (UserEventType) {
    UserEventType[UserEventType["Created"] = 0] = "Created";
    UserEventType[UserEventType["LoginSuccess"] = 1] = "LoginSuccess";
    UserEventType[UserEventType["InvitationEmailSent"] = 2] = "InvitationEmailSent";
    UserEventType[UserEventType["InvitationCompleted"] = 3] = "InvitationCompleted";
    UserEventType[UserEventType["PassphraseResetEmailSent"] = 4] = "PassphraseResetEmailSent";
    UserEventType[UserEventType["PassphraseReset"] = 5] = "PassphraseReset";
    UserEventType[UserEventType["Deactivated"] = 6] = "Deactivated";
    UserEventType[UserEventType["Activated"] = 7] = "Activated";
})(UserEventType || (UserEventType = {}));

var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["None"] = 0] = "None";
    UserStatus[UserStatus["Invited"] = 1] = "Invited";
    UserStatus[UserStatus["Active"] = 2] = "Active";
    UserStatus[UserStatus["Inactive"] = 3] = "Inactive";
})(UserStatus || (UserStatus = {}));

var VehicleConditionStatus;
(function (VehicleConditionStatus) {
    VehicleConditionStatus[VehicleConditionStatus["Clean"] = 1] = "Clean";
    VehicleConditionStatus[VehicleConditionStatus["Dirty"] = 2] = "Dirty";
})(VehicleConditionStatus || (VehicleConditionStatus = {}));

var VehicleFuelType;
(function (VehicleFuelType) {
    VehicleFuelType[VehicleFuelType["Petrol"] = 1] = "Petrol";
    VehicleFuelType[VehicleFuelType["Diesel"] = 2] = "Diesel";
    VehicleFuelType[VehicleFuelType["Electric"] = 3] = "Electric";
    VehicleFuelType[VehicleFuelType["Hybrid"] = 4] = "Hybrid";
})(VehicleFuelType || (VehicleFuelType = {}));

var WeatherConditionStatus;
(function (WeatherConditionStatus) {
    WeatherConditionStatus[WeatherConditionStatus["Wet"] = 1] = "Wet";
    WeatherConditionStatus[WeatherConditionStatus["Dry"] = 2] = "Dry";
})(WeatherConditionStatus || (WeatherConditionStatus = {}));

var VehicleOilLevelStatus;
(function (VehicleOilLevelStatus) {
    VehicleOilLevelStatus[VehicleOilLevelStatus["High"] = 1] = "High";
    VehicleOilLevelStatus[VehicleOilLevelStatus["Ok"] = 2] = "Ok";
    VehicleOilLevelStatus[VehicleOilLevelStatus["Low"] = 3] = "Low";
})(VehicleOilLevelStatus || (VehicleOilLevelStatus = {}));

const _c0$b = ["fileInput"];
class FilePickerComponent {
    constructor() {
        this.selected = new EventEmitter();
        this.invalidSelection = new EventEmitter();
        this.fileSelection = new BehaviorSubject(null);
    }
    ngOnInit() {
        this.fileInputChangeSubscription = fromEvent(this.fileInput.nativeElement, "change")
            .subscribe(() => {
            let fileList = this.fileInput.nativeElement.files;
            let invalid = false;
            if (fileList != null) {
                for (let i = 0; i < fileList.length; i++) {
                    let file = fileList[i];
                    if (!this.validateFileSize(file)) {
                        this.invalidSelection.emit("File exceeds maximum size");
                        invalid = true;
                    }
                    else if (!this.validateFileType(file)) {
                        this.invalidSelection.emit("File type not accepted");
                        invalid = true;
                    }
                }
                if (!invalid) {
                    this.selected.next(fileList);
                    this.fileSelection.next(fileList);
                }
                this.fileInput.nativeElement.value = null;
            }
        });
    }
    ngOnDestroy() {
        this.fileInputChangeSubscription.unsubscribe();
    }
    select() {
        setTimeout(() => {
            this.fileInput.nativeElement.click();
        });
    }
    clear() {
        if (this.fileSelection.value) {
            this.fileSelection.next(null);
        }
    }
    validateFileSize(file) {
        if (this.maxSize && file.size > this.maxSize) {
            return false;
        }
        return true;
    }
    validateFileType(file) {
        if (this.accept) {
            let regex = /\.[0-9a-z]+$/i;
            let extension = regex.exec(file.name.toLowerCase())[0];
            let acceptedExtensions = this.accept.split(",");
            if (acceptedExtensions.indexOf(extension) == -1) {
                return false;
            }
        }
        return true;
    }
}
FilePickerComponent.ɵfac = function FilePickerComponent_Factory(t) { return new (t || FilePickerComponent)(); };
FilePickerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FilePickerComponent, selectors: [["file-picker"]], viewQuery: function FilePickerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵstaticViewQuery(_c0$b, true);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { accept: "accept", maxSize: "maxSize", multiple: "multiple" }, outputs: { selected: "selected", invalidSelection: "invalidSelection" }, decls: 3, vars: 2, consts: [[2, "display", "none"], ["type", "file", 3, "accept", "multiple"], ["fileInput", ""]], template: function FilePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "input", 1, 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("accept", ctx.accept);
        i0.ɵɵproperty("multiple", ctx.multiple);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FilePickerComponent, [{
        type: Component,
        args: [{
                selector: "file-picker",
                templateUrl: "./FilePickerComponent.html"
            }]
    }], function () { return []; }, { accept: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], multiple: [{
            type: Input
        }], selected: [{
            type: Output
        }], invalidSelection: [{
            type: Output
        }], fileInput: [{
            type: ViewChild,
            args: ["fileInput", { static: true }]
        }] }); })();

function FilePickerToggleComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function FilePickerToggleComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.filePicker.select(); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "attach_file");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FilePickerToggleComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function FilePickerToggleComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.filePicker.clear(); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class FilePickerToggleComponent {
    ngOnChanges() {
        if (this.fileSelectedSubsciption) {
            this.fileSelectedSubsciption.unsubscribe();
        }
        if (this.filePicker) {
            this.fileSelectedSubsciption = this.filePicker
                .fileSelection
                .subscribe(fileModel => {
                this.isFileSelected = fileModel != null;
            });
        }
    }
    ngOnDestroy() {
        if (this.fileSelectedSubsciption) {
            this.fileSelectedSubsciption.unsubscribe();
        }
    }
}
FilePickerToggleComponent.ɵfac = function FilePickerToggleComponent_Factory(t) { return new (t || FilePickerToggleComponent)(); };
FilePickerToggleComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FilePickerToggleComponent, selectors: [["file-picker-toggle"]], inputs: { filePicker: ["for", "filePicker"] }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "click"]], template: function FilePickerToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FilePickerToggleComponent_button_0_Template, 3, 0, "button", 0);
        i0.ɵɵtemplate(1, FilePickerToggleComponent_button_1_Template, 3, 0, "button", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isFileSelected);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isFileSelected);
    } }, directives: [i2.NgIf, i2$1.MatButton, i3.MatIcon], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FilePickerToggleComponent, [{
        type: Component,
        args: [{
                selector: "file-picker-toggle",
                templateUrl: "./FilePickerToggleComponent.html"
            }]
    }], null, { filePicker: [{
            type: Input,
            args: ["for"]
        }] }); })();

class FilePickerModule {
}
FilePickerModule.ɵmod = i0.ɵɵdefineNgModule({ type: FilePickerModule });
FilePickerModule.ɵinj = i0.ɵɵdefineInjector({ factory: function FilePickerModule_Factory(t) { return new (t || FilePickerModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatButtonModule,
            MatIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FilePickerModule, { declarations: [FilePickerComponent,
        FilePickerToggleComponent], imports: [CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule], exports: [FilePickerComponent,
        FilePickerToggleComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FilePickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatButtonModule,
                    MatIconModule
                ],
                exports: [
                    FilePickerComponent,
                    FilePickerToggleComponent
                ],
                declarations: [
                    FilePickerComponent,
                    FilePickerToggleComponent
                ]
            }]
    }], null, null); })();

class FileBase64Model {
}

const _c0$a = ["*"];
class FlexBladeBodyComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    getCurrentScrollHeight() {
        return this.elementRef.nativeElement.scrollHeight;
    }
    scrollToTop() {
        this.elementRef.nativeElement.scrollTop = 0;
    }
    scrollToBottom() {
        this.elementRef.nativeElement.scrollTop = this.elementRef.nativeElement.scrollHeight;
    }
    setScrollHeight(scrollHeight) {
        this.elementRef.nativeElement.scrollTop = scrollHeight;
    }
}
FlexBladeBodyComponent.ɵfac = function FlexBladeBodyComponent_Factory(t) { return new (t || FlexBladeBodyComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
FlexBladeBodyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FlexBladeBodyComponent, selectors: [["flex-blade-body"]], hostVars: 2, hostBindings: function FlexBladeBodyComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("theme-bg-background-transparent", true);
    } }, exportAs: ["flexBladeBody"], ngContentSelectors: _c0$a, decls: 1, vars: 0, template: function FlexBladeBodyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["flex-blade-body{flex:1 1 auto;min-height:1px;overflow-y:auto;display:block;padding:10px;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.flex-blade-body-container{height:100%;display:flex;flex-direction:column}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeBodyComponent, [{
        type: Component,
        args: [{
                selector: "flex-blade-body",
                exportAs: "flexBladeBody",
                templateUrl: "./FlexBladeBodyComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styleUrls: ["./FlexBladeBodyComponent.scss"],
                encapsulation: ViewEncapsulation.None,
                host: {
                    "[class.theme-bg-background-transparent]": "true",
                }
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();

class FlexBladeOutletDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    ngOnChanges() {
        this.viewContainerRef.clear();
        this.viewContainerRef.createEmbeddedView(this.template);
    }
}
FlexBladeOutletDirective.ɵfac = function FlexBladeOutletDirective_Factory(t) { return new (t || FlexBladeOutletDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
FlexBladeOutletDirective.ɵdir = i0.ɵɵdefineDirective({ type: FlexBladeOutletDirective, selectors: [["", "flex-blade-outlet", ""]], inputs: { template: "template" }, features: [i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeOutletDirective, [{
        type: Directive,
        args: [{
                selector: "[flex-blade-outlet]"
            }]
    }], function () { return [{ type: i0.ViewContainerRef }]; }, { template: [{
            type: Input
        }] }); })();

const _c0$9 = ["scroll"];
function FlexBladeLayoutComponent_2_ng_template_0_Template(rf, ctx) { }
function FlexBladeLayoutComponent_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FlexBladeLayoutComponent_2_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    const template_r2 = ctx.$implicit;
    i0.ɵɵproperty("template", template_r2.template);
} }
const _c1$5 = ["*"];
class FlexBladeLayoutComponent {
    constructor(media) {
        this.media = media;
        this.templates = [];
    }
    ngOnInit() {
        this.mediaSubscription = this.media
            .asObservable()
            .subscribe(() => {
            if (this.media.isActive("xl")) {
                this.flexBladeLayoutClass = "flex-blade-layout-xl";
            }
            else if (this.media.isActive("lg")) {
                this.flexBladeLayoutClass = "flex-blade-layout-lg";
            }
            else if (this.media.isActive("md")) {
                this.flexBladeLayoutClass = "flex-blade-layout-md";
            }
            else if (this.media.isActive("sm")) {
                this.flexBladeLayoutClass = "flex-blade-layout-sm";
            }
            else {
                this.flexBladeLayoutClass = "flex-blade-layout-xs";
            }
        });
    }
    ngOnDestroy() {
        this.mediaSubscription.unsubscribe();
    }
    addTemplateRef(index, templateRef) {
        this.templates.push({
            index: index,
            template: templateRef
        });
        this.sortTemplates();
        setTimeout(() => {
            this.scrollRight();
        }, 0);
    }
    removeTemplateRef(templateRef) {
        let index = this.templates.findIndex(t => t.template == templateRef);
        if (index != -1) {
            this.templates.splice(index, 1);
        }
    }
    scrollRight(smooth) {
        this.scrollH(this.scroll.nativeElement.scrollWidth, smooth !== false);
    }
    windowResized() {
        this.scrollRight(false);
    }
    scrollH(offset, smooth) {
        if (smooth && this.scroll.nativeElement.scroll) {
            this.scroll.nativeElement.scroll({
                left: offset,
                behavior: "smooth"
            });
        }
        else {
            this.scroll.nativeElement.scrollLeft = offset;
        }
    }
    sortTemplates() {
        this.templates = this.templates.sort((a, b) => {
            if (a.index > b.index) {
                return 1;
            }
            if (a.index < b.index) {
                return -1;
            }
            return 0;
        });
    }
}
FlexBladeLayoutComponent.ɵfac = function FlexBladeLayoutComponent_Factory(t) { return new (t || FlexBladeLayoutComponent)(i0.ɵɵdirectiveInject(i1$4.MediaObserver)); };
FlexBladeLayoutComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FlexBladeLayoutComponent, selectors: [["flex-blade-layout"]], viewQuery: function FlexBladeLayoutComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$9, true);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scroll = _t.first);
    } }, hostBindings: function FlexBladeLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function FlexBladeLayoutComponent_resize_HostBindingHandler() { return ctx.windowResized(); }, false, i0.ɵɵresolveWindow);
    } }, ngContentSelectors: _c1$5, decls: 4, vars: 2, consts: [[1, "flex-blade-layout-container", "overflow-x-auto", 3, "ngClass"], ["scroll", ""], [4, "ngFor", "ngForOf"], ["flex-blade-outlet", "", 3, "template"]], template: function FlexBladeLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵtemplate(2, FlexBladeLayoutComponent_2_Template, 1, 1, undefined, 2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.flexBladeLayoutClass);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.templates);
    } }, directives: [i2.NgClass, i3$1.DefaultClassDirective, i2.NgForOf, FlexBladeOutletDirective], styles: ["flex-blade-layout{display:flex;overflow:hidden}flex-blade-layout>.flex-blade-layout-container{flex:1 1 auto;display:flex;flex-direction:row;flex-wrap:nowrap;align-items:stretch;padding:5px;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs{position:relative;padding:0}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy{position:absolute;height:100%;width:100%;max-width:100%;top:0;left:0;padding:0;z-index:1}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy:not(:last-of-type),flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy:not(:last-of-type){display:none}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .loading-overlay,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .loading-overlay{margin:0;border-radius:0}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card{border-radius:0;overflow-y:auto}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card flex-blade-head,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card flex-blade-head{border-radius:0}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card flex-blade-body,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card flex-blade-body{border-radius:0;flex:1 0 auto;min-height:0;overflow-y:visible}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card flex-blade-foot,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card flex-blade-foot{border-radius:0}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card .mat-tab-group,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card .mat-tab-group{min-height:unset}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card .mat-tab-group>.mat-tab-body-wrapper>.mat-tab-body,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card .mat-tab-group>.mat-tab-body-wrapper>.mat-tab-body{overflow-y:visible}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-sm .flex-blade-proxy .flex-blade-proxy-card .mat-tab-group>.mat-tab-body-wrapper>.mat-tab-body>.mat-tab-body-content,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xs .flex-blade-proxy .flex-blade-proxy-card .mat-tab-group>.mat-tab-body-wrapper>.mat-tab-body>.mat-tab-body-content{border-radius:0;flex:1 0 auto;min-height:0;overflow-y:visible}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-md .flex-blade-proxy-sm{flex-basis:50%;max-width:50%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-md .flex-blade-proxy-lg,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-md .flex-blade-proxy-md,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-md .flex-blade-proxy-xl{flex-basis:100%;max-width:100%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-lg .flex-blade-proxy-sm{flex-basis:34%;max-width:34%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-lg .flex-blade-proxy-md{flex-basis:66%;max-width:66%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-lg .flex-blade-proxy-lg,flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-lg .flex-blade-proxy-xl{flex-basis:100%;max-width:100%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xl .flex-blade-proxy-sm{flex-basis:25%;max-width:25%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xl .flex-blade-proxy-md{flex-basis:50%;max-width:50%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xl .flex-blade-proxy-lg{flex-basis:75%;max-width:75%}flex-blade-layout>.flex-blade-layout-container.flex-blade-layout-xl .flex-blade-proxy-xl{flex-basis:100%;max-width:100%}"], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeLayoutComponent, [{
        type: Component,
        args: [{
                selector: "flex-blade-layout",
                templateUrl: "./FlexBladeLayoutComponent.html",
                encapsulation: ViewEncapsulation.None,
                styleUrls: ["./FlexBladeLayoutComponent.scss"]
            }]
    }], function () { return [{ type: i1$4.MediaObserver }]; }, { scroll: [{
            type: ViewChild,
            args: ["scroll"]
        }], windowResized: [{
            type: HostListener,
            args: ["window:resize"]
        }] }); })();
class FlexBladeTemplateModel {
}

class FlexBladeTemplateDirective {
    constructor(templateRef, flexBladeLayoutComponent) {
        this.templateRef = templateRef;
        this.flexBladeLayoutComponent = flexBladeLayoutComponent;
    }
    ngOnInit() {
        this.flexBladeLayoutComponent.addTemplateRef(this.index, this.templateRef);
    }
    ngOnDestroy() {
        this.flexBladeLayoutComponent.removeTemplateRef(this.templateRef);
    }
}
FlexBladeTemplateDirective.ɵfac = function FlexBladeTemplateDirective_Factory(t) { return new (t || FlexBladeTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(FlexBladeLayoutComponent)); };
FlexBladeTemplateDirective.ɵdir = i0.ɵɵdefineDirective({ type: FlexBladeTemplateDirective, selectors: [["", "flexBladeTemplate", ""]], inputs: { index: ["flexBladeTemplate", "index"] } });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeTemplateDirective, [{
        type: Directive,
        args: [{
                selector: "[flexBladeTemplate]"
            }]
    }], function () { return [{ type: i0.TemplateRef }, { type: FlexBladeLayoutComponent }]; }, { index: [{
            type: Input,
            args: ["flexBladeTemplate"]
        }] }); })();

function FlexBladeComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "mat-progress-spinner", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@fadeIn", undefined);
} }
const _c0$8 = function (a0, a1, a2, a3) { return { "flex-blade-proxy-sm": a0, "flex-blade-proxy-md": a1, "flex-blade-proxy-lg": a2, "flex-blade-proxy-xl": a3 }; };
function FlexBladeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FlexBladeComponent_div_0_div_1_Template, 3, 1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(2, _c0$8, ctx_r0.bindClassFlexBladeSm, ctx_r0.bindClassFlexBladeMd, ctx_r0.bindClassFlexBladeLg, ctx_r0.bindClassFlexBladeXl));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showOverlay);
} }
const _c1$4 = ["*"];
class FlexBladeComponent {
    ngOnInit() {
        this.setClassBindings();
    }
    ngOnChanges() {
        this.setClassBindings();
    }
    setClassBindings() {
        this.bindClassFlexBladeSm = this.size == "sm";
        this.bindClassFlexBladeMd = this.size == "md";
        this.bindClassFlexBladeLg = this.size == "lg";
        this.bindClassFlexBladeXl = this.size == "xl";
    }
}
FlexBladeComponent.ɵfac = function FlexBladeComponent_Factory(t) { return new (t || FlexBladeComponent)(); };
FlexBladeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FlexBladeComponent, selectors: [["flex-blade"]], inputs: { size: "size", index: "index", showOverlay: "showOverlay" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$4, decls: 1, vars: 1, consts: [["class", "flex-blade-proxy", 3, "ngClass", 4, "flexBladeTemplate"], [1, "flex-blade-proxy", 3, "ngClass"], ["class", "flex-blade-loading-overlay theme-bg-background-transparent", 4, "ngIf"], [1, "flex-blade-proxy-card"], [1, "flex-blade-loading-overlay", "theme-bg-background-transparent"], [1, "flex-blade-loading-content", "theme-bg-card", "mat-elevation-z2"], ["mode", "indeterminate"]], template: function FlexBladeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, FlexBladeComponent_div_0_Template, 4, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("flexBladeTemplate", ctx.index);
    } }, directives: [FlexBladeTemplateDirective, i2.NgClass, i3$1.DefaultClassDirective, i2.NgIf, i4.MatProgressSpinner], styles: [".flex-blade-proxy{position:relative;display:flex;flex-direction:column;padding:5px;flex-shrink:0;flex-grow:0;flex-basis:100%;max-width:100%;min-width:1px}.flex-blade-proxy .flex-blade-proxy-card{position:relative;height:100%;flex:1 1 auto;display:flex;flex-direction:column;border-radius:4px}.flex-blade-proxy .flex-blade-proxy-card>:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.flex-blade-proxy .flex-blade-proxy-card>:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px}.flex-blade-proxy .flex-blade-proxy-card>.mat-tab-group{flex:1 1 auto;min-height:1px}.flex-blade-proxy .flex-blade-proxy-card>.mat-tab-group>.mat-tab-header{z-index:1;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.flex-blade-proxy .flex-blade-proxy-card>.mat-tab-group>.mat-tab-body-wrapper{flex:1 1 auto}.flex-blade-proxy .flex-blade-proxy-card>.mat-tab-group>.mat-tab-body-wrapper>.mat-tab-body{flex:1 1 auto;display:flex;flex-direction:column}.flex-blade-proxy .flex-blade-proxy-card>.mat-tab-group>.mat-tab-body-wrapper>.mat-tab-body>.mat-tab-body-content{flex:1 1 auto;border-bottom-left-radius:4px;border-bottom-right-radius:4px;height:100%;padding:0;min-height:1px;overflow-y:auto;display:flex;flex-direction:column}.flex-blade-proxy .flex-blade-proxy-card .flex-blade-body-container{height:100%;display:flex;flex-direction:column}.flex-blade-proxy .flex-blade-loading-overlay{position:absolute;top:0;bottom:0;left:0;right:0;z-index:10;display:flex;flex-direction:column;border-radius:4px;margin:5px;cursor:wait}.flex-blade-proxy .flex-blade-loading-overlay>.flex-blade-loading-content{margin:auto;text-align:center;padding:10px;border-radius:50%}"], encapsulation: 2, data: { animation: [
            trigger("fadeIn", [
                transition("void => *", [
                    style({ opacity: "0" }),
                    animate("250ms", style({ opacity: "1" }))
                ]),
                transition("* => void", [
                    style({ opacity: "1" }),
                    animate("250ms", style({ opacity: "0" }))
                ])
            ])
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeComponent, [{
        type: Component,
        args: [{
                selector: "flex-blade",
                templateUrl: "./FlexBladeComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                styleUrls: ["./FlexBladeComponent.scss"],
                animations: [
                    trigger("fadeIn", [
                        transition("void => *", [
                            style({ opacity: "0" }),
                            animate("250ms", style({ opacity: "1" }))
                        ]),
                        transition("* => void", [
                            style({ opacity: "1" }),
                            animate("250ms", style({ opacity: "0" }))
                        ])
                    ])
                ]
            }]
    }], null, { size: [{
            type: Input
        }], index: [{
            type: Input
        }], showOverlay: [{
            type: Input
        }] }); })();

const _c0$7 = ["*"];
class FlexBladeFootComponent {
}
FlexBladeFootComponent.ɵfac = function FlexBladeFootComponent_Factory(t) { return new (t || FlexBladeFootComponent)(); };
FlexBladeFootComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FlexBladeFootComponent, selectors: [["flex-blade-foot"]], hostVars: 2, hostBindings: function FlexBladeFootComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("theme-bg-card", true);
    } }, ngContentSelectors: _c0$7, decls: 1, vars: 0, template: function FlexBladeFootComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["flex-blade-foot{flex:0 0 auto;display:block;padding:10px 15px;border-top:1px solid rgba(0,0,0,.12);overflow:hidden;z-index:1;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeFootComponent, [{
        type: Component,
        args: [{
                selector: "flex-blade-foot",
                templateUrl: "./FlexBladeFootComponent.html",
                styleUrls: ["./FlexBladeFootComponent.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    "[class.theme-bg-card]": "true",
                }
            }]
    }], null, null); })();

const _c0$6 = [[["", "flex-blade-head-prefix", ""]], "*", [["", "flex-blade-head-subtitle", ""]], [["", "flex-blade-head-suffix", ""]], [["", "flex-blade-head-search", ""]]];
const _c1$3 = ["[flex-blade-head-prefix]", "*", "[flex-blade-head-subtitle]", "[flex-blade-head-suffix]", "[flex-blade-head-search]"];
class FlexBladeHeadComponent {
}
FlexBladeHeadComponent.ɵfac = function FlexBladeHeadComponent_Factory(t) { return new (t || FlexBladeHeadComponent)(); };
FlexBladeHeadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FlexBladeHeadComponent, selectors: [["flex-blade-head"]], hostVars: 2, hostBindings: function FlexBladeHeadComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("theme-bg-card", true);
    } }, ngContentSelectors: _c1$3, decls: 10, vars: 0, consts: [[1, "flex-blade-head-container"], [1, "flex-blade-head-content"], [1, "flex-blade-head-title"], [1, "flex-blade-head-subtitle"], [1, "flex-blade-head-search", "theme-bg-card"]], template: function FlexBladeHeadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$6);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(7, 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵprojection(9, 4);
        i0.ɵɵelementEnd();
    } }, styles: ["flex-blade-head{flex:0 0 auto;display:block;border-bottom:1px solid rgba(0,0,0,.12);z-index:1;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}flex-blade-head>.flex-blade-head-container{min-height:56px;height:56px;padding:0 10px;display:flex;flex-direction:row;align-items:center}flex-blade-head>.flex-blade-head-container>.flex-blade-head-content{flex:1 1 auto;padding:5px;min-width:1px}flex-blade-head>.flex-blade-head-container>.flex-blade-head-content>.flex-blade-head-title{font-size:24px;line-height:26px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}flex-blade-head>.flex-blade-head-container>.flex-blade-head-content>.flex-blade-head-subtitle{font-weight:400;font-size:14px;line-height:18px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}flex-blade-head>.flex-blade-head-search:not(:empty){margin-top:-5px;padding-left:15px;padding-right:15px;padding-bottom:10px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeHeadComponent, [{
        type: Component,
        args: [{
                selector: "flex-blade-head",
                templateUrl: "./FlexBladeHeadComponent.html",
                styleUrls: ["./FlexBladeHeadComponent.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    "[class.theme-bg-card]": "true",
                }
            }]
    }], null, null); })();

class FlexBladeModule {
}
FlexBladeModule.ɵmod = i0.ɵɵdefineNgModule({ type: FlexBladeModule });
FlexBladeModule.ɵinj = i0.ɵɵdefineInjector({ factory: function FlexBladeModule_Factory(t) { return new (t || FlexBladeModule)(); }, imports: [[
            CommonModule,
            MatProgressSpinnerModule,
            FlexLayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FlexBladeModule, { declarations: [FlexBladeComponent,
        FlexBladeHeadComponent,
        FlexBladeBodyComponent,
        FlexBladeFootComponent,
        FlexBladeLayoutComponent,
        FlexBladeOutletDirective,
        FlexBladeTemplateDirective], imports: [CommonModule,
        MatProgressSpinnerModule,
        FlexLayoutModule], exports: [FlexBladeComponent,
        FlexBladeHeadComponent,
        FlexBladeBodyComponent,
        FlexBladeFootComponent,
        FlexBladeLayoutComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FlexBladeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatProgressSpinnerModule,
                    FlexLayoutModule
                ],
                exports: [
                    FlexBladeComponent,
                    FlexBladeHeadComponent,
                    FlexBladeBodyComponent,
                    FlexBladeFootComponent,
                    FlexBladeLayoutComponent,
                ],
                declarations: [
                    FlexBladeComponent,
                    FlexBladeHeadComponent,
                    FlexBladeBodyComponent,
                    FlexBladeFootComponent,
                    FlexBladeLayoutComponent,
                    FlexBladeOutletDirective,
                    FlexBladeTemplateDirective,
                ]
            }]
    }], null, null); })();

const _c0$5 = [[["grid-cell"]]];
const _c1$2 = ["grid-cell"];
class GridRowComponent {
    constructor(observableMedia) {
        this.observableMedia = observableMedia;
    }
    ngOnInit() {
        this.effectiveCols = new BehaviorSubject(this.getEffectiveCols());
        this.mediaSubscription = this.observableMedia
            .media$
            .subscribe(change => {
            this.updateEffectiveCols();
        });
    }
    ngOnDestroy() {
        this.mediaSubscription.unsubscribe();
    }
    updateEffectiveCols() {
        this.effectiveCols.next(this.getEffectiveCols());
    }
    getEffectiveCols() {
        let effectiveCols = 1;
        if (this.cols != null) {
            effectiveCols = this.cols;
        }
        if (this.colsXl != null) {
            effectiveCols = this.colsXl;
        }
        if (this.colsLg != null && this.observableMedia.isActive("lt-xl")) {
            effectiveCols = this.colsLg;
        }
        if (this.colsMd != null && this.observableMedia.isActive("lt-lg")) {
            effectiveCols = this.colsMd;
        }
        if (this.colsSm != null && this.observableMedia.isActive("lt-md")) {
            effectiveCols = this.colsSm;
        }
        if (this.colsXs != null && this.observableMedia.isActive("lt-sm")) {
            effectiveCols = this.colsXs;
        }
        return effectiveCols;
    }
}
GridRowComponent.ɵfac = function GridRowComponent_Factory(t) { return new (t || GridRowComponent)(i0.ɵɵdirectiveInject(i1$4.MediaObserver)); };
GridRowComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GridRowComponent, selectors: [["grid-row"]], inputs: { cols: "cols", colsXs: ["cols.xs", "colsXs"], colsSm: ["cols.sm", "colsSm"], colsMd: ["cols.md", "colsMd"], colsLg: ["cols.lg", "colsLg"], colsXl: ["cols.xl", "colsXl"] }, ngContentSelectors: _c1$2, decls: 1, vars: 0, template: function GridRowComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$5);
        i0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{margin:0 -10px;padding:0 5px;display:flex;flex-direction:row;flex-wrap:wrap}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GridRowComponent, [{
        type: Component,
        args: [{
                selector: "grid-row",
                templateUrl: "./GridRowComponent.html",
                styleUrls: ["./GridRowComponent.scss"]
            }]
    }], function () { return [{ type: i1$4.MediaObserver }]; }, { cols: [{
            type: Input
        }], colsXs: [{
            type: Input,
            args: ["cols.xs"]
        }], colsSm: [{
            type: Input,
            args: ["cols.sm"]
        }], colsMd: [{
            type: Input,
            args: ["cols.md"]
        }], colsLg: [{
            type: Input,
            args: ["cols.lg"]
        }], colsXl: [{
            type: Input,
            args: ["cols.xl"]
        }] }); })();

const _c0$4 = ["*"];
class GridCellComponent {
    constructor(gridRow, observableMedia, changeDetector) {
        this.gridRow = gridRow;
        this.observableMedia = observableMedia;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.currentColsSubscription = this.gridRow
            .effectiveCols
            .subscribe(effectiveCols => {
            let effectiveColSpan = this.getEffectiveColspan(effectiveCols);
            let flexPercent = (100 / effectiveCols) * effectiveColSpan;
            this.width = flexPercent + "%";
            this.changeDetector.markForCheck();
        });
    }
    ngOnDestroy() {
        this.currentColsSubscription.unsubscribe();
    }
    getEffectiveColspan(effectiveCols) {
        let effectiveColspan = 1;
        if (this.colspan != null) {
            effectiveColspan = this.colspan;
        }
        if (this.colspanXl != null) {
            effectiveColspan = this.colspanXl;
        }
        if (this.colspanLg != null && this.observableMedia.isActive("lt-xl")) {
            effectiveColspan = this.colspanLg;
        }
        if (this.colspanMd != null && this.observableMedia.isActive("lt-lg")) {
            effectiveColspan = this.colspanMd;
        }
        if (this.colspanSm != null && this.observableMedia.isActive("lt-md")) {
            effectiveColspan = this.colspanSm;
        }
        if (this.colspanXs != null && this.observableMedia.isActive("lt-sm")) {
            effectiveColspan = this.colspanXs;
        }
        return effectiveCols > effectiveColspan
            ? effectiveColspan
            : effectiveCols;
    }
}
GridCellComponent.ɵfac = function GridCellComponent_Factory(t) { return new (t || GridCellComponent)(i0.ɵɵdirectiveInject(forwardRef(() => GridRowComponent), 1), i0.ɵɵdirectiveInject(i1$4.MediaObserver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
GridCellComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GridCellComponent, selectors: [["grid-cell"]], hostVars: 2, hostBindings: function GridCellComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.width);
    } }, inputs: { colspan: "colspan", colspanXs: ["colspan.xs", "colspanXs"], colspanSm: ["colspan.sm", "colspanSm"], colspanMd: ["colspan.md", "colspanMd"], colspanLg: ["colspan.lg", "colspanLg"], colspanXl: ["colspan.xl", "colspanXl"] }, ngContentSelectors: _c0$4, decls: 1, vars: 0, template: function GridCellComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{padding:0 5px;flex-grow:0;flex-shrink:0;flex-basis:auto}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GridCellComponent, [{
        type: Component,
        args: [{
                selector: "grid-cell",
                templateUrl: "./GridCellComponent.html",
                styleUrls: ["./GridCellComponent.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: GridRowComponent, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(() => GridRowComponent)]
            }] }, { type: i1$4.MediaObserver }, { type: i0.ChangeDetectorRef }]; }, { width: [{
            type: HostBinding,
            args: ["style.width"]
        }], colspan: [{
            type: Input
        }], colspanXs: [{
            type: Input,
            args: ["colspan.xs"]
        }], colspanSm: [{
            type: Input,
            args: ["colspan.sm"]
        }], colspanMd: [{
            type: Input,
            args: ["colspan.md"]
        }], colspanLg: [{
            type: Input,
            args: ["colspan.lg"]
        }], colspanXl: [{
            type: Input,
            args: ["colspan.xl"]
        }] }); })();

class GridModule {
}
GridModule.ɵmod = i0.ɵɵdefineNgModule({ type: GridModule });
GridModule.ɵinj = i0.ɵɵdefineInjector({ factory: function GridModule_Factory(t) { return new (t || GridModule)(); }, imports: [[
            CommonModule,
            FlexLayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GridModule, { declarations: [GridRowComponent,
        GridCellComponent], imports: [CommonModule,
        FlexLayoutModule], exports: [GridRowComponent,
        GridCellComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GridModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FlexLayoutModule
                ],
                exports: [
                    GridRowComponent,
                    GridCellComponent
                ],
                declarations: [
                    GridRowComponent,
                    GridCellComponent
                ]
            }]
    }], null, null); })();

function GalleryThumbnailComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "mat-spinner", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@fadeIn", undefined);
} }
function GalleryThumbnailComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "more_vert");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(7);
    i0.ɵɵproperty("matMenuTriggerFor", _r3);
} }
const _c0$3 = [[["", "gallery-thumbnail-image", ""]], [["", "gallery-thumbnail-content", ""]], [["", "gallery-thumbnail-action", ""]]];
const _c1$1 = ["[gallery-thumbnail-image]", "[gallery-thumbnail-content]", "[gallery-thumbnail-action]"];
class GalleryThumbnailComponent {
    constructor() {
        this.showOverlay = false;
        this.imageHeight = "100px";
        this.imageMinWidth = "80px";
        this.hasActions = false;
    }
}
GalleryThumbnailComponent.ɵfac = function GalleryThumbnailComponent_Factory(t) { return new (t || GalleryThumbnailComponent)(); };
GalleryThumbnailComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GalleryThumbnailComponent, selectors: [["gallery-thumbnail"]], inputs: { showOverlay: "showOverlay", imageHeight: "imageHeight", imageMinWidth: "imageMinWidth", hasActions: "hasActions" }, ngContentSelectors: _c1$1, decls: 9, vars: 6, consts: [[1, "gallery-thumbnail-image-wrapper"], ["class", "loading-overlay", 4, "ngIf"], ["mat-icon-button", "", "class", "gallery-thumbnail-action-menu-trigger", 3, "matMenuTriggerFor", 4, "ngIf"], [1, "gallery-thumbnail-action-menu"], ["actionMenuElement", "", "actionMenu", "matMenu"], [1, "loading-overlay"], [1, "loading-content"], ["color", "accent", "diameter", "50"], ["mat-icon-button", "", 1, "gallery-thumbnail-action-menu-trigger", 3, "matMenuTriggerFor"]], template: function GalleryThumbnailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$3);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(2, 1, ["class", "gallery-thumbnail-content"]);
        i0.ɵɵtemplate(3, GalleryThumbnailComponent_div_3_Template, 3, 1, "div", 1);
        i0.ɵɵtemplate(4, GalleryThumbnailComponent_button_4_Template, 3, 1, "button", 2);
        i0.ɵɵelementStart(5, "mat-menu", 3, 4);
        i0.ɵɵprojection(8, 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleProp("height", ctx.imageHeight)("min-width", ctx.imageMinWidth);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showOverlay);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasActions && !ctx.showOverlay);
    } }, directives: [i2.NgIf, i2$2.MatMenu, i4.MatSpinner, i2$1.MatButton, i2$2.MatMenuTrigger, i3.MatIcon], styles: ["gallery-thumbnail{flex:0 0 auto;border-radius:4px;position:relative;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}gallery-thumbnail .gallery-thumbnail-image-wrapper{background:#000;flex:1 1 auto;display:flex}gallery-thumbnail .gallery-thumbnail-image-wrapper [gallery-thumbnail-image]{display:block;width:100%;-o-object-fit:contain;object-fit:contain}gallery-thumbnail .gallery-thumbnail-content{flex:0 0 auto;display:flex}gallery-thumbnail .gallery-thumbnail-header{flex:0 0 auto;display:flex;flex-direction:row}gallery-thumbnail .gallery-thumbnail-header .gallery-thumbnail-description{flex:1 0 auto;display:flex}gallery-thumbnail .gallery-thumbnail-header .gallery-thumbnail-menu-trigger{flex:0 0 auto;display:flex}gallery-thumbnail>.loading-overlay{position:absolute;top:0;bottom:0;left:0;right:0;z-index:3;display:flex;flex-direction:column;border-radius:4px;background-color:rgba(0,0,0,.6)}gallery-thumbnail>.loading-overlay>.loading-content{margin:auto}gallery-thumbnail>.gallery-thumbnail-action-menu-trigger{position:absolute;top:0;right:0;z-index:2;color:#fff!important}gallery-thumbnail>.gallery-thumbnail-action-menu-trigger .mat-icon{filter:drop-shadow(0 0 2px black)}"], encapsulation: 2, data: { animation: [
            trigger("fadeIn", [
                transition("void => *", [
                    style({ opacity: "0" }),
                    animate("100ms", style({ opacity: "1" }))
                ]),
                transition("* => void", [
                    style({ opacity: "1" }),
                    animate("100ms", style({ opacity: "0" }))
                ])
            ])
        ] } });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GalleryThumbnailComponent, [{
        type: Component,
        args: [{
                selector: "gallery-thumbnail",
                templateUrl: "./GalleryThumbnailComponent.html",
                styleUrls: ["./GalleryThumbnailComponent.scss"],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger("fadeIn", [
                        transition("void => *", [
                            style({ opacity: "0" }),
                            animate("100ms", style({ opacity: "1" }))
                        ]),
                        transition("* => void", [
                            style({ opacity: "1" }),
                            animate("100ms", style({ opacity: "0" }))
                        ])
                    ])
                ]
            }]
    }], null, { showOverlay: [{
            type: Input
        }], imageHeight: [{
            type: Input
        }], imageMinWidth: [{
            type: Input
        }], hasActions: [{
            type: Input
        }] }); })();

function GalleryDialogComponent_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, "\n");
} }
function GalleryDialogComponent_img_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 14);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("src", ctx_r1.displayedImage.fullSrc, i0.ɵɵsanitizeUrl);
} }
function GalleryDialogComponent_div_10_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "dialogDescriptionTemplate; context: { image: displayedImage }"]);
} }
const _c0$2 = function (a0) { return { image: a0 }; };
function GalleryDialogComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, GalleryDialogComponent_div_10_ng_content_1_Template, 1, 0, "ng-content", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.dialogDescriptionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$2, ctx_r2.displayedImage));
} }
function GalleryDialogComponent_gallery_thumbnail_12_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "gallery-thumbnail", 17);
    i0.ɵɵlistener("click", function GalleryDialogComponent_gallery_thumbnail_12_Template_gallery_thumbnail_click_0_listener() { i0.ɵɵrestoreView(_r8); const $index_r6 = ctx.index; const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.thumbnailClicked($index_r6); });
    i0.ɵɵelement(1, "img", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const image_r5 = ctx.$implicit;
    const $index_r6 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("theme-boxshadow-active", $index_r6 == ctx_r3.selectedIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("src", image_r5.thumbnailSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", image_r5.fileName);
    i0.ɵɵpropertyInterpolate("title", image_r5.fileName);
} }
const _c1 = ["*"];
class GalleryDialogComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    ngOnInit() {
        this.setDisplayedImage();
    }
    thumbnailClicked(index) {
        this.selectedIndex = index;
        this.setDisplayedImage();
    }
    move(delta) {
        let targetIndex = this.selectedIndex + delta;
        if (targetIndex < this.images.length
            && targetIndex >= 0) {
            this.selectedIndex = targetIndex;
            this.setDisplayedImage();
        }
    }
    setDisplayedImage() {
        if (this.images) {
            this.displayedImage = this.images[this.selectedIndex];
        }
    }
}
GalleryDialogComponent.ɵfac = function GalleryDialogComponent_Factory(t) { return new (t || GalleryDialogComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef)); };
GalleryDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GalleryDialogComponent, selectors: [["gallery-dialog"]], ngContentSelectors: _c1, decls: 18, vars: 4, consts: [["mat-dialog-title", "", 4, "ngIf"], ["mat-dialog-content", "", 1, "theme-bg-background"], [1, "gallery-image-display"], ["type", "button", "mat-fab", "", 1, "gallery-nav", "gallery-nav-previous", 3, "click"], ["type", "button", "mat-fab", "", 1, "gallery-nav", "gallery-nav-next", 3, "click"], ["alt", "", 3, "src", 4, "ngIf"], ["class", "p-2 pb-0 text-center", 4, "ngIf"], ["fxLayout", "row", "fxLayoutAlign", "center", 1, "overflow-x-auto", "p-2"], ["fxFlex", "0 0 auto", "class", "m-1 c-pointer", "imageHeight", "128px", 3, "theme-boxshadow-active", "click", 4, "ngFor", "ngForOf"], [1, "flex-width-2"], ["mat-dialog-actions", "", 1, "theme-bg-card"], ["fxFlex", ""], ["mat-raised-button", "", "color", "primary", 3, "click"], ["mat-dialog-title", ""], ["alt", "", 3, "src"], [1, "p-2", "pb-0", "text-center"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["fxFlex", "0 0 auto", "imageHeight", "128px", 1, "m-1", "c-pointer", 3, "click"], ["gallery-thumbnail-image", "", 3, "src", "alt", "title"]], template: function GalleryDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, GalleryDialogComponent_h2_0_Template, 2, 1, "h2", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function GalleryDialogComponent_Template_button_click_3_listener() { return ctx.move(-1); });
        i0.ɵɵelementStart(4, "mat-icon");
        i0.ɵɵtext(5, "navigate_before");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "button", 4);
        i0.ɵɵlistener("click", function GalleryDialogComponent_Template_button_click_6_listener() { return ctx.move(1); });
        i0.ɵɵelementStart(7, "mat-icon");
        i0.ɵɵtext(8, "navigate_next");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, GalleryDialogComponent_img_9_Template, 1, 1, "img", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, GalleryDialogComponent_div_10_Template, 2, 4, "div", 6);
        i0.ɵɵelementStart(11, "div", 7);
        i0.ɵɵtemplate(12, GalleryDialogComponent_gallery_thumbnail_12_Template, 2, 5, "gallery-thumbnail", 8);
        i0.ɵɵelement(13, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 10);
        i0.ɵɵelement(15, "span", 11);
        i0.ɵɵelementStart(16, "button", 12);
        i0.ɵɵlistener("click", function GalleryDialogComponent_Template_button_click_16_listener() { return ctx.dialogRef.close(false); });
        i0.ɵɵtext(17, " Close ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.title);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.displayedImage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dialogDescriptionTemplate && ctx.displayedImage);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.images);
    } }, directives: [i2.NgIf, i2$1.MatButton, i3.MatIcon, i5.DefaultLayoutDirective, i5.DefaultLayoutAlignDirective, i2.NgForOf, i5.DefaultFlexDirective, i2.NgTemplateOutlet, GalleryThumbnailComponent], styles: ["gallery-dialog{height:100%;display:flex;flex-direction:column;justify-content:stretch}gallery-dialog div[mat-dialog-title]{display:flex;flex:0 0 auto}gallery-dialog div[mat-dialog-content]{min-height:0;display:flex;flex:1 1 auto;flex-direction:column}gallery-dialog div[mat-dialog-content] .gallery-image-display{flex-direction:column;justify-content:stretch;height:100%;width:100%;background:#000;display:flex;flex:1 1 0;min-height:0;position:relative}gallery-dialog div[mat-dialog-content] .gallery-image-display>img{-o-object-fit:contain;object-fit:contain;height:100%;width:100%}gallery-dialog div[mat-dialog-content] .gallery-image-display .gallery-nav{position:absolute;top:50%;z-index:1000;background:hsla(0,0%,100%,.6);color:#000}gallery-dialog div[mat-dialog-content] .gallery-image-display .gallery-nav.gallery-nav-previous{left:20px}gallery-dialog div[mat-dialog-content] .gallery-image-display .gallery-nav.gallery-nav-next{right:20px}gallery-dialog div[mat-dialog-actions]{display:flex;flex:0 0 auto;padding:10px 15px;border-top:1px solid rgba(0,0,0,.12)}"], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GalleryDialogComponent, [{
        type: Component,
        args: [{
                selector: "gallery-dialog",
                templateUrl: "./GalleryDialogComponent.html",
                styleUrls: ["./GalleryDialogComponent.scss"],
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }]; }, null); })();

class GalleryService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    openDialog(images, selectedIndex) {
        let openDialog = this.dialog.open(GalleryDialogComponent, {
            maxHeight: "95vh",
            maxWidth: "95vw",
            height: "95vw",
            width: "95vw",
            panelClass: "overlay-dialog-p-0",
        });
        let galleryDialog = openDialog.componentInstance;
        galleryDialog.images = images;
        galleryDialog.selectedIndex = selectedIndex;
        return galleryDialog;
    }
}
GalleryService.ɵfac = function GalleryService_Factory(t) { return new (t || GalleryService)(i0.ɵɵinject(i1$1.MatDialog)); };
GalleryService.ɵprov = i0.ɵɵdefineInjectable({ token: GalleryService, factory: GalleryService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GalleryService, [{
        type: Injectable
    }], function () { return [{ type: i1$1.MatDialog }]; }, null); })();

class GalleryModule {
}
GalleryModule.ɵmod = i0.ɵɵdefineNgModule({ type: GalleryModule });
GalleryModule.ɵinj = i0.ɵɵdefineInjector({ factory: function GalleryModule_Factory(t) { return new (t || GalleryModule)(); }, providers: [
        GalleryService,
    ], imports: [[
            CommonModule,
            DialogModule,
            FlexLayoutModule,
            MatButtonModule,
            MatMenuModule,
            MatIconModule,
            MatProgressSpinnerModule,
            GridModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GalleryModule, { declarations: [GalleryThumbnailComponent,
        GalleryDialogComponent], imports: [CommonModule,
        DialogModule,
        FlexLayoutModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        GridModule], exports: [GalleryThumbnailComponent,
        GalleryDialogComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GalleryModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DialogModule,
                    FlexLayoutModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatIconModule,
                    MatProgressSpinnerModule,
                    GridModule,
                ],
                exports: [
                    GalleryThumbnailComponent,
                    GalleryDialogComponent,
                ],
                declarations: [
                    GalleryThumbnailComponent,
                    GalleryDialogComponent,
                ],
                entryComponents: [
                    GalleryDialogComponent,
                ],
                providers: [
                    GalleryService,
                ]
            }]
    }], null, null); })();

class GoogleMapsAddressSearchResultModel {
}

class GoogleMapsAddressSearchDirective {
    constructor(mapsAPILoader, ngZone, elementRef, ngControl) {
        this.mapsAPILoader = mapsAPILoader;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.ngControl = ngControl;
        this.addressSelected = new EventEmitter();
    }
    ngOnInit() {
        this.mapsAPILoader
            .load()
            .then(() => {
            this.autocomplete = new google.maps.places.Autocomplete(this.elementRef.nativeElement, {
                types: ["address"],
                componentRestrictions: { country: ["nz"] }
            });
            this.autocomplete.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    // Get the place result
                    let place = this.autocomplete.getPlace();
                    // Verify result
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }
                    let searchResult = this.getSearchResult(place);
                    this.emitSearchResult(searchResult);
                    this.setControlValue(searchResult);
                });
            });
        });
    }
    ngOnDestroy() {
        if (this.autocomplete) {
            this.autocomplete.unbindAll();
        }
    }
    getSearchResult(place) {
        let street_number;
        let route;
        let sublocality;
        let locality;
        let country;
        let postal_code;
        let administrative_area_level_1;
        place.address_components.forEach(comp => {
            comp.types.forEach(type => {
                if (type == "street_number") {
                    street_number = comp.short_name;
                }
                else if (type == "route") {
                    route = comp.short_name;
                }
                else if (type == "sublocality") {
                    sublocality = comp.long_name;
                }
                else if (type == "locality") {
                    locality = comp.long_name;
                }
                else if (type == "country") {
                    country = comp.long_name;
                }
                else if (type == "postal_code") {
                    postal_code = comp.long_name;
                }
                else if (type == "administrative_area_level_1") {
                    administrative_area_level_1 = comp.long_name;
                }
            });
        });
        let result = new GoogleMapsAddressSearchResultModel();
        result.formattedAddress = place.formatted_address;
        result.addressLines = street_number + " " + route + ", " + sublocality;
        result.city = locality;
        result.region = administrative_area_level_1;
        result.country = country;
        result.postalCode = postal_code;
        result.latitude = place.geometry.location.lat();
        result.longitude = place.geometry.location.lng();
        return result;
    }
    emitSearchResult(searchResult) {
        this.addressSelected.emit(searchResult);
    }
    setControlValue(searchResult) {
        if (this.ngControl) {
            this.ngControl.control.setValue(searchResult.formattedAddress);
        }
    }
}
GoogleMapsAddressSearchDirective.ɵfac = function GoogleMapsAddressSearchDirective_Factory(t) { return new (t || GoogleMapsAddressSearchDirective)(i0.ɵɵdirectiveInject(i1$5.MapsAPILoader), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.NgControl, 8)); };
GoogleMapsAddressSearchDirective.ɵdir = i0.ɵɵdefineDirective({ type: GoogleMapsAddressSearchDirective, selectors: [["", "googleMapsAddressSearch", ""]], outputs: { addressSelected: "addressSelected" }, exportAs: ["googleMapsAddressSearch"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GoogleMapsAddressSearchDirective, [{
        type: Directive,
        args: [{
                selector: "[googleMapsAddressSearch]",
                exportAs: "googleMapsAddressSearch"
            }]
    }], function () { return [{ type: i1$5.MapsAPILoader }, { type: i0.NgZone }, { type: i0.ElementRef }, { type: i1$2.NgControl, decorators: [{
                type: Optional
            }] }]; }, { addressSelected: [{
            type: Output
        }] }); })();

class GoogleMapsModule {
}
GoogleMapsModule.ɵmod = i0.ɵɵdefineNgModule({ type: GoogleMapsModule });
GoogleMapsModule.ɵinj = i0.ɵɵdefineInjector({ factory: function GoogleMapsModule_Factory(t) { return new (t || GoogleMapsModule)(); }, imports: [[
            AgmCoreModule,
            CommonModule,
            MatFormFieldModule,
            MatInputModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GoogleMapsModule, { declarations: [GoogleMapsAddressSearchDirective], imports: [AgmCoreModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule], exports: [GoogleMapsAddressSearchDirective] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GoogleMapsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    AgmCoreModule,
                    CommonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    FormsModule
                ],
                exports: [
                    GoogleMapsAddressSearchDirective
                ],
                declarations: [
                    GoogleMapsAddressSearchDirective
                ]
            }]
    }], null, null); })();

class HttpBlobService {
    saveFile(response) {
        try {
            let filename = '';
            const disposition = response.headers.get('Content-Disposition');
            const type = response.headers.get('Content-Type');
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            const blob = new Blob([response.body], { type: type });
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                // IE workaround
                window.navigator.msSaveBlob(blob, filename);
            }
            else {
                const URL = window.URL || window.webkitURL;
                const downloadUrl = URL.createObjectURL(blob);
                if (filename) {
                    // use HTML5 a[download] attribute to specify filename
                    const a = document.createElement('a');
                    // safari doesn't support this yet
                    if (typeof a.download === 'undefined') {
                        window.location.href = downloadUrl;
                    }
                    else {
                        a.href = downloadUrl;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                }
                else {
                    window.location.href = downloadUrl;
                }
                setTimeout(() => { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
            }
        }
        catch (ex) {
            console.error('Error downloading file. Ensure your browser is up to date.', ex);
        }
    }
}
HttpBlobService.ɵfac = function HttpBlobService_Factory(t) { return new (t || HttpBlobService)(); };
HttpBlobService.ɵprov = i0.ɵɵdefineInjectable({ token: HttpBlobService, factory: HttpBlobService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(HttpBlobService, [{
        type: Injectable
    }], null, null); })();

class HttpExceptionInterceptor {
    constructor() {
        this.httpErrorSubject = new Subject();
    }
    intercept(request, next) {
        return next
            .handle(request)
            .pipe(tap((response) => { }, (response) => {
            if (response instanceof HttpErrorResponse) {
                if (response.status === -1) {
                    // Page is probably reloading - do nothing
                }
                else if (response.status === 401) {
                    // Expired Cookie or X-XSRF-TOKEN
                    //window.location.href = "/reload";
                    this.httpErrorSubject
                        .next({
                        message: "Unauthorised"
                    });
                }
                else if (response.status === 404) {
                    // Not found or deleted
                    this.httpErrorSubject
                        .next({
                        message: "Resource not found"
                    });
                }
                else {
                    // Exception
                    let message = "Server Error";
                    let model = response.error;
                    if (model && model.message) {
                        message = model.message;
                    }
                    this.httpErrorSubject
                        .next({
                        message: message
                    });
                }
            }
        }));
    }
}
HttpExceptionInterceptor.ɵfac = function HttpExceptionInterceptor_Factory(t) { return new (t || HttpExceptionInterceptor)(); };
HttpExceptionInterceptor.ɵprov = i0.ɵɵdefineInjectable({ token: HttpExceptionInterceptor, factory: HttpExceptionInterceptor.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(HttpExceptionInterceptor, [{
        type: Injectable
    }], function () { return []; }, null); })();

class HttpModule {
}
HttpModule.ɵmod = i0.ɵɵdefineNgModule({ type: HttpModule });
HttpModule.ɵinj = i0.ɵɵdefineInjector({ factory: function HttpModule_Factory(t) { return new (t || HttpModule)(); }, providers: [
        HttpBlobService,
        HttpExceptionInterceptor,
        { provide: HTTP_INTERCEPTORS, useExisting: HttpExceptionInterceptor, multi: true },
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HttpModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(HttpModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                providers: [
                    HttpBlobService,
                    HttpExceptionInterceptor,
                    { provide: HTTP_INTERCEPTORS, useExisting: HttpExceptionInterceptor, multi: true },
                ]
            }]
    }], null, null); })();

class HttpExceptionModel {
}

const _c0$1 = ["*"];
class LabelComponent {
    constructor() {
        this.color = "default";
        this.classLabelDefaultBinding = true;
    }
    ngOnChanges() {
        this.classLabelDefaultBinding = this.color == "default";
        this.classLabelPrimaryBinding = this.color == "primary";
        this.classLabelAccentBinding = this.color == "accent";
        this.classLabelWarnBinding = this.color == "warn";
        this.classLabelInfoBinding = this.color == "info";
        this.classLabelSuccessBinding = this.color == "success";
    }
}
LabelComponent.ɵfac = function LabelComponent_Factory(t) { return new (t || LabelComponent)(); };
LabelComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LabelComponent, selectors: [["label"]], hostVars: 12, hostBindings: function LabelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("label-default", ctx.classLabelDefaultBinding)("label-primary", ctx.classLabelPrimaryBinding)("label-accent", ctx.classLabelAccentBinding)("label-warn", ctx.classLabelWarnBinding)("label-info", ctx.classLabelInfoBinding)("label-success", ctx.classLabelSuccessBinding);
    } }, inputs: { color: "color" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function LabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:inline;line-height:1em;padding:.1em .5em;font-size:.8em;border-radius:3px}.label-default[_nghost-%COMP%]{background-color:grey;color:#fff}.label-primary[_nghost-%COMP%]{background-color:#469769;color:#fff}.label-accent[_nghost-%COMP%]{background-color:#976946;color:#fff}.label-warn[_nghost-%COMP%]{background-color:#f15a4f;color:#fff}.label-info[_nghost-%COMP%]{background-color:#2b8ae3;color:#fff}.label-success[_nghost-%COMP%]{background-color:#4aa124;color:#fff}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LabelComponent, [{
        type: Component,
        args: [{
                selector: "label",
                templateUrl: "./LabelComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styleUrls: ["./LabelComponent.scss"],
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], classLabelDefaultBinding: [{
            type: HostBinding,
            args: ["class.label-default"]
        }], classLabelPrimaryBinding: [{
            type: HostBinding,
            args: ["class.label-primary"]
        }], classLabelAccentBinding: [{
            type: HostBinding,
            args: ["class.label-accent"]
        }], classLabelWarnBinding: [{
            type: HostBinding,
            args: ["class.label-warn"]
        }], classLabelInfoBinding: [{
            type: HostBinding,
            args: ["class.label-info"]
        }], classLabelSuccessBinding: [{
            type: HostBinding,
            args: ["class.label-success"]
        }] }); })();

function UserStatusLabelComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1, "Active");
    i0.ɵɵelementEnd();
} }
function UserStatusLabelComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1, "Inactive");
    i0.ɵɵelementEnd();
} }
function UserStatusLabelComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵtext(1, "Invited");
    i0.ɵɵelementEnd();
} }
class UserStatusLabelComponent {
    constructor() {
        this.UserStatus = UserStatus;
    }
}
UserStatusLabelComponent.ɵfac = function UserStatusLabelComponent_Factory(t) { return new (t || UserStatusLabelComponent)(); };
UserStatusLabelComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UserStatusLabelComponent, selectors: [["user-status-label"]], inputs: { status: "status" }, decls: 3, vars: 3, consts: [["color", "success", 4, "ngIf"], [4, "ngIf"], ["color", "info", 4, "ngIf"], ["color", "success"], ["color", "info"]], template: function UserStatusLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, UserStatusLabelComponent_label_0_Template, 2, 0, "label", 0);
        i0.ɵɵtemplate(1, UserStatusLabelComponent_label_1_Template, 2, 0, "label", 1);
        i0.ɵɵtemplate(2, UserStatusLabelComponent_label_2_Template, 2, 0, "label", 2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.status == ctx.UserStatus.Active);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.status == ctx.UserStatus.Inactive);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.status == ctx.UserStatus.Invited);
    } }, directives: [i2.NgIf, LabelComponent], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UserStatusLabelComponent, [{
        type: Component,
        args: [{
                selector: "user-status-label",
                templateUrl: "./UserStatusLabelComponent.html",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { status: [{
            type: Input
        }] }); })();

class LabelModule {
}
LabelModule.ɵmod = i0.ɵɵdefineNgModule({ type: LabelModule });
LabelModule.ɵinj = i0.ɵɵdefineInjector({ factory: function LabelModule_Factory(t) { return new (t || LabelModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LabelModule, { declarations: [LabelComponent,
        UserStatusLabelComponent], imports: [CommonModule], exports: [LabelComponent,
        UserStatusLabelComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                exports: [
                    LabelComponent,
                    UserStatusLabelComponent,
                ],
                declarations: [
                    LabelComponent,
                    UserStatusLabelComponent,
                ]
            }]
    }], null, null); })();

class LoadingOverlayService {
    constructor() {
        this.overlayCount = 0;
        this.showOverlaySubject = new BehaviorSubject(false);
    }
    show() {
        this.overlayCount++;
        this.showOverlaySubject.next(true);
    }
    hide(force) {
        if (this.overlayCount > 0) {
            this.overlayCount--;
        }
        if (force === true) {
            this.overlayCount = 0;
        }
        if (this.overlayCount == 0) {
            this.showOverlaySubject.next(false);
        }
    }
}
LoadingOverlayService.ɵfac = function LoadingOverlayService_Factory(t) { return new (t || LoadingOverlayService)(); };
LoadingOverlayService.ɵprov = i0.ɵɵdefineInjectable({ token: LoadingOverlayService, factory: LoadingOverlayService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LoadingOverlayService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "loading-overlay-show": a0 }; };
class LoadingOverlayComponent {
    constructor(loadingOverlay) {
        this.loadingOverlay = loadingOverlay;
        this.showOverlay = false;
        this.loadingSubscription = this.loadingOverlay.showOverlaySubject.subscribe(isLoading => {
            this.showOverlay = isLoading;
        });
    }
    ngOnDestroy() {
        this.loadingSubscription.unsubscribe();
    }
}
LoadingOverlayComponent.ɵfac = function LoadingOverlayComponent_Factory(t) { return new (t || LoadingOverlayComponent)(i0.ɵɵdirectiveInject(LoadingOverlayService)); };
LoadingOverlayComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LoadingOverlayComponent, selectors: [["loading-overlay"]], decls: 3, vars: 3, consts: [[1, "loading-overlay", "theme-bg-overlay", 3, "ngClass"], [1, "loading-overlay-content", "theme-bg-card"]], template: function LoadingOverlayComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "mat-spinner");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx.showOverlay));
    } }, directives: [i2.NgClass, i3$1.DefaultClassDirective, i4.MatSpinner], styles: ["[_nghost-%COMP%]   .loading-overlay[_ngcontent-%COMP%]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:10000;display:flex;flex-direction:column;align-items:center;visibility:hidden;opacity:0;transition:all .4s ease-in}[_nghost-%COMP%]   .loading-overlay.loading-overlay-show[_ngcontent-%COMP%]{visibility:visible;opacity:1}[_nghost-%COMP%]   .loading-overlay[_ngcontent-%COMP%]   .loading-overlay-content[_ngcontent-%COMP%]{margin:auto;padding:10px;border-radius:50%;box-shadow:0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12)}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LoadingOverlayComponent, [{
        type: Component,
        args: [{
                selector: "loading-overlay",
                templateUrl: "./LoadingOverlayComponent.html",
                styleUrls: ["./LoadingOverlayComponent.scss"]
            }]
    }], function () { return [{ type: LoadingOverlayService }]; }, null); })();

class LoadingOverlayModule {
}
LoadingOverlayModule.ɵmod = i0.ɵɵdefineNgModule({ type: LoadingOverlayModule });
LoadingOverlayModule.ɵinj = i0.ɵɵdefineInjector({ factory: function LoadingOverlayModule_Factory(t) { return new (t || LoadingOverlayModule)(); }, providers: [
        LoadingOverlayService
    ], imports: [[
            CommonModule,
            FlexLayoutModule,
            MatProgressSpinnerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoadingOverlayModule, { declarations: [LoadingOverlayComponent], imports: [CommonModule,
        FlexLayoutModule,
        MatProgressSpinnerModule], exports: [LoadingOverlayComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LoadingOverlayModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FlexLayoutModule,
                    MatProgressSpinnerModule
                ],
                exports: [
                    LoadingOverlayComponent
                ],
                declarations: [
                    LoadingOverlayComponent
                ],
                providers: [
                    LoadingOverlayService
                ]
            }]
    }], null, null); })();

function SelectorClearComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function SelectorClearComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.clearClicked(); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.disabled);
} }
class SelectorClearComponent {
    clearClicked() {
        if (this.selector != null) {
            this.selector.clear();
        }
    }
}
SelectorClearComponent.ɵfac = function SelectorClearComponent_Factory(t) { return new (t || SelectorClearComponent)(); };
SelectorClearComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SelectorClearComponent, selectors: [["selector-clear"]], inputs: { selector: ["for", "selector"], disabled: "disabled" }, decls: 1, vars: 1, consts: [["mat-icon-button", "", "tabindex", "-1", 3, "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", "tabindex", "-1", 3, "disabled", "click"]], template: function SelectorClearComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SelectorClearComponent_button_0_Template, 3, 1, "button", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selector.selected);
    } }, directives: [i2.NgIf, i2$1.MatButton, i3.MatIcon], styles: ["selector-clear .mat-icon-button{height:1.5em!important;width:1.5em!important}selector-clear .mat-icon-button .mat-icon{height:1em!important;width:1em!important}.selector-not-selected{color:#777;text-decoration:line-through}.selector-not-selected:focus{color:inherit;text-decoration:none}"], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SelectorClearComponent, [{
        type: Component,
        args: [{
                selector: "selector-clear",
                templateUrl: "./SelectorClearComponent.html",
                styleUrls: ["./SelectorClearComponent.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { selector: [{
            type: Input,
            args: ["for"]
        }], disabled: [{
            type: Input,
            args: ["disabled"]
        }] }); })();

class SelectorDirective {
    constructor(control) {
        this.control = control;
        this.selectorCleared = new EventEmitter();
    }
    keydownHandler(event) {
        if (event.key === "Escape" || event.key == "Backspace") {
            if (this.selected) {
                this.clear();
            }
        }
    }
    ngOnChanges() {
        this.readonlyBinding = this.selected;
        this.classNotSelectedBinding = !this.selected;
        this.control.control.updateValueAndValidity();
    }
    clear() {
        this.control.control.setValue(null);
        this.selectorCleared.emit();
    }
}
SelectorDirective.ɵfac = function SelectorDirective_Factory(t) { return new (t || SelectorDirective)(i0.ɵɵdirectiveInject(i1$2.NgControl)); };
SelectorDirective.ɵdir = i0.ɵɵdefineDirective({ type: SelectorDirective, selectors: [["", "selector", ""]], hostVars: 3, hostBindings: function SelectorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown", function SelectorDirective_keydown_HostBindingHandler($event) { return ctx.keydownHandler($event); });
    } if (rf & 2) {
        i0.ɵɵhostProperty("readonly", ctx.readonlyBinding);
        i0.ɵɵclassProp("selector-not-selected", ctx.classNotSelectedBinding);
    } }, inputs: { selected: ["selector", "selected"] }, outputs: { selectorCleared: "selectorCleared" }, exportAs: ["selector"], features: [i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SelectorDirective, [{
        type: Directive,
        args: [{
                selector: "[selector]",
                exportAs: "selector"
            }]
    }], function () { return [{ type: i1$2.NgControl }]; }, { selected: [{
            type: Input,
            args: ["selector"]
        }], selectorCleared: [{
            type: Output,
            args: ["selectorCleared"]
        }], keydownHandler: [{
            type: HostListener,
            args: ["keydown", ["$event"]]
        }], readonlyBinding: [{
            type: HostBinding,
            args: ["readonly"]
        }], classNotSelectedBinding: [{
            type: HostBinding,
            args: ["class.selector-not-selected"]
        }] }); })();

class SelectorRequiredValidatorDirective {
    validate(control) {
        if (this.selector && !this.selector.selected) {
            return {
                selectorRequired: true
            };
        }
        return null;
    }
    registerOnValidatorChange(fn) {
        this.registerValidatorChanged = fn;
    }
    ngOnChanges() {
        if (this.registerValidatorChanged) {
            setTimeout(() => {
                this.registerValidatorChanged();
            }, 0);
        }
    }
}
SelectorRequiredValidatorDirective.ɵfac = function SelectorRequiredValidatorDirective_Factory(t) { return new (t || SelectorRequiredValidatorDirective)(); };
SelectorRequiredValidatorDirective.ɵdir = i0.ɵɵdefineDirective({ type: SelectorRequiredValidatorDirective, selectors: [["", "selectorRequired", ""]], inputs: { selector: ["selectorRequired", "selector"] }, features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: SelectorRequiredValidatorDirective, multi: true }]), i0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SelectorRequiredValidatorDirective, [{
        type: Directive,
        args: [{
                selector: "[selectorRequired]",
                providers: [{ provide: NG_VALIDATORS, useExisting: SelectorRequiredValidatorDirective, multi: true }]
            }]
    }], null, { selector: [{
            type: Input,
            args: ["selectorRequired"]
        }] }); })();

class SelectorModule {
}
SelectorModule.ɵmod = i0.ɵɵdefineNgModule({ type: SelectorModule });
SelectorModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SelectorModule_Factory(t) { return new (t || SelectorModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatButtonModule,
            MatIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SelectorModule, { declarations: [SelectorClearComponent,
        SelectorDirective,
        SelectorRequiredValidatorDirective], imports: [CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule], exports: [SelectorClearComponent,
        SelectorDirective,
        SelectorRequiredValidatorDirective] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatButtonModule,
                    MatIconModule
                ],
                exports: [
                    SelectorClearComponent,
                    SelectorDirective,
                    SelectorRequiredValidatorDirective
                ],
                declarations: [
                    SelectorClearComponent,
                    SelectorDirective,
                    SelectorRequiredValidatorDirective
                ]
            }]
    }], null, null); })();

class StorageService {
    isLocalAvailable() {
        if (typeof localStorage === "object") {
            try {
                localStorage.getItem("test");
                return true;
            }
            catch (ex) {
            }
        }
        return false;
    }
    getLocal(key) {
        if (this.isLocalAvailable()) {
            let json = localStorage.getItem(key);
            if (json != null) {
                return JSON.parse(json);
            }
        }
        return null;
    }
    setLocal(key, item) {
        if (this.isLocalAvailable()) {
            let json = JSON.stringify(item);
            localStorage.setItem(key, json);
        }
    }
}
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
StorageService.ɵprov = i0.ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(StorageService, [{
        type: Injectable
    }], null, null); })();

class StorageModule {
}
StorageModule.ɵmod = i0.ɵɵdefineNgModule({ type: StorageModule });
StorageModule.ɵinj = i0.ɵɵdefineInjector({ factory: function StorageModule_Factory(t) { return new (t || StorageModule)(); }, providers: [
        StorageService,
    ] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(StorageModule, [{
        type: NgModule,
        args: [{
                providers: [
                    StorageService,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertModule, AppNotificationType, AutoFocusDirective, AutoSelectDirective, AvatarComponent, AvatarModule, BookedThroughType, CardBodyDirective, CardComponent, CardFootDirective, CardHeadComponent, CardModule, ChecklistStatus, DateModule, DialogAlertComponent, DialogAlertViewModel, DialogConfirmComponent, DialogConfirmViewModel, DialogModule, EntityAction, ExpandableDirective, ExpandableToggleDirective, FileBase64Model, FilePickerComponent, FilePickerModule, FilePickerToggleComponent, FlexBladeBodyComponent, FlexBladeComponent, FlexBladeFootComponent, FlexBladeHeadComponent, FlexBladeLayoutComponent, FlexBladeModule, FlexBladeOutletDirective, FlexBladeTemplateDirective, FlexBladeTemplateModel, ForbiddenValueValidatorDirective, FormExtensionsModule, FormHelperDirective, GalleryDialogComponent, GalleryModule, GalleryService, GalleryThumbnailComponent, GoogleMapsAddressSearchDirective, GoogleMapsAddressSearchResultModel, GoogleMapsModule, GridCellComponent, GridModule, GridRowComponent, HttpBlobService, HttpExceptionInterceptor, HttpExceptionModel, HttpModule, InspectionChecklistItemResultStatus, InspectionStatus, IsValidValidatorDirective, LabelComponent, LabelModule, LetDirective, LightConditionStatus, LoadingOverlayComponent, LoadingOverlayModule, LoadingOverlayService, MatSelectAllButtonsComponent, MaxNumberValidatorDirective, MinNumberValidatorDirective, PassphraseResetResult, RequiredValueValidatorDirective, SelectorClearComponent, SelectorDirective, SelectorModule, SelectorRequiredValidatorDirective, SharedCommonModule, SnackBarConfig, StorageModule, StorageService, UserEventType, UserStatus, UserStatusLabelComponent, UtcDateAdapter, UtcDateDirective, UtcDatePipe, VehicleConditionStatus, VehicleFuelType, VehicleOilLevelStatus, WeatherConditionStatus };
//# sourceMappingURL=shared.js.map
